/* material tiers (owner 2026-11-01: base / ultra / exotic, exotic like a Destiny weapon) */
    (function(){ if(document.getElementById('va-tier-css')) return; var st=document.createElement('style'); st.id='va-tier-css';
      st.textContent='.va-tier{display:inline-flex;align-items:center;gap:4px;margin-left:6px;padding:2px 8px 2px 6px;border-radius:4px;font-size:10.5px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;vertical-align:middle;line-height:1.5;border:1px solid currentColor;white-space:nowrap}.va-tier svg{flex:none}.va-tier-base{color:#9aa7bd;background:rgba(154,167,189,.10)}.va-tier-ultra{color:#b98cff;background:rgba(150,95,255,.16)}.va-tier-exotic{color:#1a1200;border-color:#f3d36b;background:linear-gradient(110deg,#c9971c 0%,#f5d76e 38%,#fff3c4 50%,#f5d76e 62%,#c9971c 100%);background-size:220% 100%;box-shadow:0 0 10px rgba(245,205,90,.45);animation:vaExo 3.2s linear infinite}@keyframes vaExo{0%{background-position:120% 0}100%{background-position:-120% 0}}@media (prefers-reduced-motion:reduce){.va-tier-exotic{animation:none;background-position:50% 0}}html[data-vatheme="light"] .va-tier-base{color:#55627a}html[data-vatheme="light"] .va-tier-ultra{color:#6a3df0;background:rgba(106,61,240,.08)}.matcard .mattx b .va-tier{display:inline-flex;width:auto;margin:0 0 0 6px;padding:1px 7px 1px 5px;font-size:9.5px;vertical-align:2px}.matcard .mattx b .va-tier svg{display:inline-block;width:8px;height:8px}'; document.head.appendChild(st); })();
/* Serial Seal — LOST & FOUND CONTACT LABEL builder (/pages/lost-found-builder).
 *
 * ONE SCROLLING PAGE, a sibling of the seal builder (owner 2026-09-04: "this is
 * too many steps — do serial seal builder style"). The six-step wizard, the
 * progress rail, the pack-assignment machinery and the review card are gone.
 * What is left is the seal builder's own shape:
 *
 *   sticky preview + rulers → SIZE → STYLE → BACKGROUND → your details → logo
 *   → QR → material → quantity → ONE CTA with the blocker written under it
 *
 * FIVE RULES INHERITED FROM THAT BUILDER, and every one of them is load-bearing:
 *   1. No steps. Nothing is behind a "Continue".
 *   2. One CTA. Its label never changes and it is never faded — a blocked
 *      button is a live outlined button that toasts the blocker and scrolls to
 *      the control that fixes it.
 *   3. The blocker is written IN THE OPEN under the button, never only in a
 *      toast and never behind a collapsed drawer.
 *   4. The preview is the hero and carries its own picker strips, so a change
 *      is one tap from the thing it changes.
 *   5. Mobile IS the design: one 560px column, 44/48px targets, nothing under
 *      13px, and the page never scrolls sideways.
 *
 * HOLO FIRST (owner 2026-09-04: "too much black — we use holo materials, which
 * are the star"). The default ground is BARE FOIL, the preview mounts in
 * preview mode so the iridescent sweep shows, and every tile in both strips is
 * a real LT.mount of the customer's own label — not an icon, not a stock photo.
 *
 * WHAT THIS PRODUCT IS. A printed contact label. It carries the details the
 * customer types and nothing else. A code opens the customer's OWN number,
 * inbox, profile or web address directly on the finder's phone; nothing is
 * routed through us and there is nothing of ours to look up.
 *
 * COMPLETELY SEPARATE from the seal builder and the sticker builder. This file
 * shares their INFRASTRUCTURE (the upload Worker, the Skip the Production Line
 * ladder, the cart endpoints) and none of their state, DOM or scripts — no
 * ss-*.js or sv-builder.js is loaded on this page, so every helper those files
 * would have provided (toast, esc, haptics, refocus) is carried here.
 *
 * TWO PRODUCTS, ONE PER DIE. LT_CFG.packs is the Standard product's variants,
 * LT_CFG.packsLarge is the Large product's. The product IS the size, so a Large
 * label can never ride a Standard SKU. Large sells on Aurora only.
 *
 * ONE DESIGN PER CART LINE. st.labels stays a ONE-ELEMENT array so toCompact /
 * fromCompact / wirePayload and tools/lt_builder_check.py read the same shape
 * they always did; cur() is always st.labels[0].
 *
 * CART QUANTITY IS THE NUMBER OF PACKS (the seal semantics), never 1 —
 * gt-builder.js carts quantity:1 because its pack size lives in the SKU; here
 * the SKU is one pack of twelve and the customer buys N of them.
 *
 * PRIVACY. These fields are a real person's name, phone, email and possibly a
 * street address. A cart property is PUBLIC unless its key starts with an
 * underscore, so the public properties on the line are generic (Pack, Designs,
 * Size, Material) and every contact string lives inside the private `_lt` JSON.
 *
 * MONEY RULES (house): every displayed figure derives from the variant price
 * Shopify will actually charge — per-label = price/12, computed, never typed
 * (the $142-for-24-seals lesson, 2026-08-28) — and the discount is floored
 * PER UNIT with the +1e-6 epsilon, which is what checkout actually does.
 */
(function () {
  'use strict';
  var CFG = window.LT_CFG || {};
  var LT = window.LT;

  var SID_STD = 'standard_177x075';
  var SID_LG = 'large_250x100';
  var PAGE = CFG.page || '/pages/lost-found-builder';

  /* ── variants, from the products Shopify actually sells ──
     LABELS PER PACK COMES FROM THE SKU (SVN-LOST-12-AUR -> 12): the one place
     the count lives, shared by the builder, the rush ladder and Label Farm. A
     property a browser wrote is never trusted downstream, so it is not trusted
     here either. */
  function perPackOf(sku) {
    var m = /^SVN-LOST(W?)-(\d+)(?:-|$)/.exec(String(sku || '').toUpperCase());
    return m ? parseInt(m[2], 10) : 0;
  }
  function mapVariants(list, sizeId) {
    return (list || []).map(function (v) {
      return {
        id: v.id, sku: v.sku, sizeId: sizeId,
        material: String(v.material || v.title || '').trim(),
        cents: parseInt(v.price, 10) || 0,
        perPack: perPackOf(v.sku),
        available: v.available !== false
      };
    }).filter(function (v) { return v.id && v.cents && v.perPack; });
  }
  var VARIANTS = {};
  VARIANTS[SID_STD] = mapVariants(CFG.packs, SID_STD);
  VARIANTS[SID_LG] = mapVariants(CFG.packsLarge, SID_LG);

  function sizeLive(sizeId) {
    var pub = sizeId === SID_LG ? CFG.publishedAtLarge : CFG.publishedAt;
    return !!(pub && (VARIANTS[sizeId] || []).filter(function (v) { return v.available; }).length);
  }
  function variantsFor(sizeId) {
    return (VARIANTS[sizeId] || []).filter(function (v) { return v.available; });
  }
  /* never fall back onto an unavailable variant — that is a /cart/add.js 422 */
  function variantFor(sizeId, material) {
    var vs = variantsFor(sizeId);
    var want = String(material || '').toLowerCase();
    for (var i = 0; i < vs.length; i++) if (vs[i].material.toLowerCase() === want) return vs[i];
    return vs[0] || null;
  }
  function variantById(id) {
    var all = variantsFor(SID_STD).concat(variantsFor(SID_LG));
    for (var i = 0; i < all.length; i++) if (String(all[i].id) === String(id)) return all[i];
    return null;
  }
  var OK = !!(LT && LT.mount && sizeLive(SID_STD));

  /* ── THE COMBO (owner 2026-09-28: "do the combo default at $15") ──
     Three ways to buy, one design: COMBO = one pack of the Standard die + one
     pack of the Large die per SET (the DEFAULT, never a requirement — there is
     2-unit minimum below), STANDARD ONLY, LARGE ONLY. In combo mode the
     customer designs the Standard label (st.sizeId stays SID_STD, so the style
     strip, the QR budget and the fit checks are the tighter die's) and the
     Large label is DERIVED from it: same fields, same ground, same accent,
     same logo, the style mapped by name. At the cart a set is TWO ordinary
     lines, one per product, exactly the shape a single-size order has — Label
     Farm routes each by its own SKU and never learns there was a combo.
     A combo is never rebuilt from the cart: editing a line edits that line in
     single-size mode. */
  var MODE_COMBO = 'combo', MODE_STD = 'std', MODE_LG = 'lg';
  function comboLive() { return sizeLive(SID_STD) && sizeLive(SID_LG); }
  var LG_OF = { photo: 'photo_lg', callout: 'callout_lg', plain: 'plain_lg',
                banner: 'banner_lg', strip: 'card_lg',
                line: 'line_lg', center: 'center_lg', tower: 'tower_lg',
                tower_name: 'tower_name_lg' };
  var STD_OF = {};
  for (var _lk in LG_OF) if (Object.prototype.hasOwnProperty.call(LG_OF, _lk)) STD_OF[LG_OF[_lk]] = _lk;
  /* ORIENTATION (owner 2026-09-30: "also allow vertical new layouts",
     "orientation switching"). A style IS an orientation (LT.LAYOUTS' `orient`),
     so the switch is not a second setting on the design — it moves the design
     to the matching style on the other axis, and the record still carries one
     key. A no-code centred card has no vertical twin of its own; the vertical
     card reflows without a code, so it takes its place. */
  var ORIENT_TWIN = { line: 'tower', center: 'tower', tower: 'line', tower_name: 'line',
                      line_lg: 'tower_lg', center_lg: 'tower_lg', tower_lg: 'line_lg',
                      tower_name_lg: 'line_lg' };

  /* ── money ──
     Liquid-embedded prices are market-converted; label them in the buyer's
     currency, not a hardcoded dollar. */
  function fmtMoney(x) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    if (cur === 'USD') return '$' + x.toFixed(2);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(x); }
    catch (e) { return '$' + x.toFixed(2); }
  }
  /* PER-LABEL money keeps a third decimal when it needs one: a 30% rung on the
     $6.00 pack lands on $0.35 exactly, but a future rate need not — and a 2dp
     round that prints "$0.35 each" beside a $4.20 pack (x12 = $4.20) is the
     same class of lie as quoting a discount checkout will not apply. */
  function fmtPerSeal(x) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var s3 = x.toFixed(3);
    var v = /0$/.test(s3) ? x.toFixed(2) : s3;
    if (cur === 'USD') return '$' + v;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur,
        minimumFractionDigits: 2, maximumFractionDigits: /0$/.test(s3) ? 2 : 3 }).format(x);
    } catch (e) { return '$' + v; }
  }
  function money(c) { return fmtMoney(c / 100); }
  function perLabel(v) { return fmtPerSeal(v.cents / v.perPack / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Thousands separator for the big label counts. The quantity input itself
     stays bare — it is type=number and a separator makes its value
     unparseable — so "6,000 labels" over "500" in the box is deliberate. */
  function sealNum(n) {
    try { return Number(n).toLocaleString('en-US'); } catch (_) { return String(n); }
  }
  /* A rate as a percentage STRING, one decimal only when it needs one. Never
     Math.round(rate*100), which prints a 42.6% rung as "43%" — a page quoting
     a discount deeper than checkout applies. */
  function pctOf(rate) {
    var t = Math.round(rate * 1000) / 10;
    return t % 1 === 0 ? String(t) : t.toFixed(1);
  }

  /* ── the helpers whose ss-*.js homes are not loaded on this page ── */
  function $(id) { return document.getElementById(id); }

  var _toastT = null;
  function toast(msg, bad) {
    var t = $('ss-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ss-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = String(msg || '');
    t.className = 'show' + (bad ? ' bad' : '');
    clearTimeout(_toastT);
    _toastT = setTimeout(function () { t.className = bad ? 'bad' : ''; }, 3800);
  }

  /* HAPTICS. navigator.vibrate is Android Chrome; iOS Safari has no web
     vibration API, so there the switch trick ticks the Taptic engine inside a
     user gesture — never an error, never a fallback sound. */
  function buzz(ms) {
    try {
      if (navigator.vibrate) { navigator.vibrate(ms || 8); return; }
      var sw = $('ss-haptic');
      if (!sw) {
        sw = document.createElement('input');
        sw.type = 'checkbox';
        try { sw.setAttribute('switch', ''); } catch (_) {}
        sw.id = 'ss-haptic';
        sw.tabIndex = -1;
        sw.setAttribute('aria-hidden', 'true');
        sw.style.cssText = 'position:fixed;left:-99px;top:0;width:1px;height:1px;' +
          'opacity:0;pointer-events:none';
        document.body.appendChild(sw);
      }
      sw.click();
    } catch (_) {}
  }
  document.addEventListener('pointerdown', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.qd-tier,.qm,.bgcar-t,.sqk-b,.cta,.logotile,.va-qsb,' +
                         '.optbtn,.qn-go,.btn,.btn2,.rs-thumb,.ss-size-card,.sw,#lt-qsl')) buzz(8);
  }, { passive: true });

  /* SC 2.4.3: a handler that re-renders its own container destroys the node
     holding focus, so focus falls to <body> and the next Tab restarts at the
     top of the page. Every such handler ends by focusing the equivalent node
     in the fresh markup. */
  function _refocus(sel, delay) {
    setTimeout(function () {
      var n = document.querySelector(sel);
      if (!n) return;
      try { n.focus({ preventScroll: true }); } catch (_) { try { n.focus(); } catch (__) {} }
    }, delay || 0);
  }
  function smoothTo(el, block) {
    if (!el) return;
    try {
      el.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: block || 'start' });
    } catch (_) { try { el.scrollIntoView(); } catch (__) {} }
  }
  function hilite(el) {
    if (!el) return;
    el.classList.remove('hilite');
    void el.offsetWidth;
    el.classList.add('hilite');
    setTimeout(function () { try { el.classList.remove('hilite'); } catch (_) {} }, 1700);
  }

  /* ── rush: the Skip the Production Line ladder, cart-wide ──
     A byte-for-byte mirror of sv-builder.js and gt-builder.js (same variant
     titles, same pure plan). If any of them disagree the builders would charge
     different fees for the same cart — change ALL or none. Lost & Found lines
     count as labelsPerPack x line quantity. */
  var RUSH_LADDER = [
    [12, '12-99 labels'], [100, '100-249 labels'], [250, '250-499 labels'],
    [500, '500-999 labels'], [1000, '1,000-2,499 labels'], [2500, '2,500-4,999 labels'],
    [5000, '5,000-9,999 labels'], [10000, '10,000+ labels']];
  var RUSH = { tiers: [] };
  (function () {
    var vs = (CFG.rush || {}).variants || [];
    RUSH.tiers = RUSH_LADDER.map(function (t) {
      var v = vs.filter(function (x) { return x.title === t[1]; })[0];
      return v ? { min: t[0], id: v.id, cents: parseInt(v.price, 10), label: t[1] } : null;
    }).filter(Boolean);
    RUSH.ok = !!((CFG.rush || {}).publishedAt && RUSH.tiers.length === RUSH_LADDER.length);
  })();
  function rushTierFor(n) {
    for (var i = RUSH.tiers.length - 1; i >= 0; i--) if (n >= RUSH.tiers[i].min) return RUSH.tiers[i];
    return RUSH.tiers[0];
  }
  function cartLabelsOf(cart) {
    return (cart.items || []).reduce(function (n, it) {
      var sku = String(it.sku || '').toUpperCase();
      var pr = it.properties || {};
      /* lost lines first: SVN-LOST/SVN-LOSTW collide with none of the prefixes
         below, but testing them first keeps the intent obvious */
      if (pr._lost_order === '1' || sku.indexOf('SVN-LOST') === 0) {
        var pp = perPackOf(sku) || 12;
        return n + pp * it.quantity;
      }
      if (sku.indexOf('SVN-PACK') === 0 || sku.indexOf('SVN-WIDE') === 0) return n + it.quantity * 12;
      var tm = /SVN-TAG-(\d+)/.exec(sku);
      if (tm) return n + parseInt(tm[1], 10) * it.quantity;
      return n;
    }, 0);
  }
  function cartRushLine(cart) {
    return (cart.items || []).filter(function (it) {
      return String(it.sku || '').toUpperCase() === 'PRIORITY-PROD' ||
             (it.properties && it.properties._ss_rush);
    })[0] || null;
  }
  function rushPlan(cart, added, want) {
    var line = cartRushLine(cart);
    var labels = cartLabelsOf(cart) + added;
    var tier = ((want || !!line) && RUSH.ok) ? rushTierFor(labels) : null;
    var stale = !!line && (!tier || String(line.variant_id) !== String(tier.id));
    return { line: line, labels: labels, tier: tier, stale: stale,
             add: !!tier && (stale || !line) };
  }
  function rushLine(tier, labels) {
    return { id: tier.id, quantity: 1, properties: {
      'Service': 'Skip the Production Line — priority production, not shipping speed',
      'Order size': tier.label, 'Labels in order': String(labels),
      'Refund': 'Refunded in full if we do not move your order ahead of the queue',
      '_ss_rush': '1' } };
  }

  /* ── state ──
     CAPS are the spec's wire caps (spec section 3). maxlength on the input AND
     value.slice(0, cap) in bindField, because a paste beats maxlength. */
  var CAP = { hdr: 26, name: 28, phone: 20, email: 40, addr1: 32, addr2: 32,
              reward: 22, social: 20, note: 28, qd: 44, qb: 40 };

  /* MEASURED, not inherited. One design at every field's cap plus a CDN logo
     URL is ~620 bytes of JSON, so a single-design line is nowhere near
     Shopify's ~64 KB of line-item properties — but PAYLOAD_MAX stays as the
     belt: the real serialized length is measured before the cart add, so an
     unusual design can never blow the limit silently. */
  var PAYLOAD_MAX = 48000;
  var MAX_PACKS = 500;
  /* THE MINIMUM (owner 2026-09-28: "2 pack minimum", "we wanted to do a $30
     target", "offer more product"). Two of whatever the stepper counts, in
     EVERY mode: 2 packs on Standard only or Large only (24 labels), 2 SETS in
     the combo (24 Standard + 24 Large — the $30 default at today's prices,
     which the page never types: it is 2 x (Standard pack + Large pack) off the
     variants). Every minimum site reads this one number: the boot quantity,
     the deep-link and draft clamps, the stepper and its disabled "-", the
     slider origin, the first price chip, the card prices, the pack line and
     blockers(). The cart holds the same floor across the whole order —
     assets/ss-cart.js (Remove guard) and snippets/cart-summary.liquid
     (checkout gate) — and snippets/cart-products.liquid holds the native
     steppers at 2. */
  var MIN_UNITS = 2;

  var HDR_PRESETS = ['IF FOUND, PLEASE CONTACT', 'IF FOUND PLEASE CALL', 'LOST? SCAN OR CALL',
                     'RETURN TO', 'PROPERTY OF', 'IF FOUND, TEXT ME'];
  var REWARD_PRESETS = ['REWARD IF FOUND', 'REWARD OFFERED', 'NO QUESTIONS ASKED'];
  var ACCENTS = ['#7c4dff', '#2f6fed', '#0e7c86', '#127a4a', '#8a6b12', '#b3560f',
                 '#b3213b', '#a01f7a'];
  var DIALS = [
    ['+1', 'US / CA'], ['+44', 'UK'], ['+61', 'AU'], ['+64', 'NZ'], ['+353', 'IE'],
    ['+33', 'FR'], ['+49', 'DE'], ['+34', 'ES'], ['+39', 'IT'], ['+31', 'NL'],
    ['+32', 'BE'], ['+41', 'CH'], ['+43', 'AT'], ['+45', 'DK'], ['+46', 'SE'],
    ['+47', 'NO'], ['+358', 'FI'], ['+351', 'PT'], ['+48', 'PL'], ['+420', 'CZ'],
    ['+30', 'GR'], ['+52', 'MX'], ['+55', 'BR'], ['+54', 'AR'], ['+56', 'CL'],
    ['+57', 'CO'], ['+27', 'ZA'], ['+971', 'AE'], ['+972', 'IL'], ['+91', 'IN'],
    ['+65', 'SG'], ['+60', 'MY'], ['+62', 'ID'], ['+63', 'PH'], ['+66', 'TH'],
    ['+81', 'JP'], ['+82', 'KR'], ['+852', 'HK'], ['+886', 'TW'], ['+86', 'CN']];

  var ACTIONS = [
    { k: 'none', n: 'No code', s: 'Text only' },
    { k: 'call', n: 'Call me', s: 'Opens the dialler' },
    { k: 'text', n: 'Text me', s: 'Opens a message' },
    { k: 'email', n: 'Email me', s: 'Opens their mail' },
    { k: 'instagram', n: 'Instagram', s: 'Opens your profile' },
    { k: 'whatsapp', n: 'WhatsApp', s: 'Opens a chat' },
    { k: 'web', n: 'My website', s: 'Opens your page' }];

  /* the canonical legal strings, authored once. The SHORT line lives in the
     section header (it is on screen the whole way down); this is the MEDIUM
     one, which the legal block and the landing page both render verbatim.
     Each clause is one unbroken literal on purpose — the copy guard reads
     these files. */
  var LEGAL_MEDIUM =
    'Custom printed contact label. It carries the contact details you type and nothing else: ' +
    'it does not track or locate an item, nothing is routed through us, and ' +
    'it cannot guarantee that a lost item is returned. ' +
    'Not affiliated with any luggage, airline, electronics or tracking-device brand.';

  /* THE DEFAULT GROUND IS THE FIRST ARTWORK (owner 2026-09-05: "the bgs suck
     compared to the Serial Seal defaults"). The shop's own designs lead the
     picker and paint the label a customer sees first. ONE name in ONE place:
     the renderer owns LT.DEFAULT_BG and every consumer reads it, so the
     builder, the cart and the press can never disagree about what an unnamed
     ground is. Bare foil stays the fallback if that export ever goes missing —
     the stock is still the product (owner 2026-09-04: "we use holo
     materials, which are the star"). */
  function bgKeys() {
    var l = (LT && LT.BGS) || [], o = [];
    for (var i = 0; i < l.length; i++) o.push(l[i].key);
    return o;
  }
  function defaultBgKey() {
    /* START_BG is the ground a NEW design opens on (bare foil since
       2026-09-30: "use less ink no dark bgs"). DEFAULT_BG stays what the
       renderer resolves a record with NO ground to, which every record this
       builder writes carries anyway (toCompact always writes bg). */
    var keys = bgKeys(), s = LT && LT.START_BG, d = LT && LT.DEFAULT_BG;
    if (s && keys.indexOf(s) >= 0) return s;
    if (d && keys.indexOf(d) >= 0) return d;
    if (keys.indexOf('holo') >= 0) return 'holo';
    return keys[0] || 'holo';
  }
  function blankLabel() {
    return { hdr: '', name: '', phone: '', e164: '', email: '', addr1: '', addr2: '',
             reward: '', social: '', note: '', qa: 'none', qd: '', qb: '',
             lo: '', accent: ACCENTS[0], layout: '', bg: defaultBgKey(), q: 1 };
  }
  /* THE DEFAULT STYLE FOLLOWS THE GROUND (owner 2026-09-05: the picture has to
     be the star). LT.layoutsFor arrives in picker order with the art-first
     style leading, and that IS the default on one of the twenty-eight
     artworks; on bare foil or a screen it would be a blank panel on a blank
     label, so those open on the type-first style instead. Same rule as the
     renderer's own LT.norm, so the builder, the cart and the press cannot
     disagree about what an unnamed style is. */
  function defaultLayout(sizeId, bgKey) {
    /* the clean set (2026-09-30): the first style the picker shows, on the
       axis the customer is on. The older ground-following rule below is kept
       for a renderer that predates pickerLayouts. */
    if (LT && LT.startLayout) {
      var ori = (typeof st !== 'undefined' && st && st.labels && st.labels[0])
        ? orientOf(st.labels[0].layout, st.sizeId) : 'h';
      return LT.startLayout(sizeId, ori);
    }
    var ls = LT ? LT.layoutsFor(sizeId) : [];
    if (!ls.length) return 'callout';
    var want = isArt(bgOf(bgKey || defaultBgKey()));
    for (var i = 0; i < ls.length; i++) if (!!ls[i].photo === want) return ls[i].key;
    return ls[0].key;
  }

  var st = { mode: comboLive() ? MODE_COMBO : MODE_STD,
             sizeId: SID_STD, material: '', packs: MIN_UNITS, rush: false,
             labels: [blankLabel()], cur: 0, editKey: '', cc: '+1',
             logo: null, rightsOk: false, _mat: {}, _fit: '' };
  st.labels[0].layout = defaultLayout(st.sizeId);
  (function bootDefaults() {
    var v = variantsFor(SID_STD)[0];
    st.material = v ? v.material : 'Shattered Prism';
    try {
      var qs = new URLSearchParams(location.search);
      var qsz = String(qs.get('size') || '').toLowerCase();
      /* ?size=standard pins STANDARD ONLY and ?size=combo pins the combo; a
         bare ?pack= / ?labels= link counts in packs of ONE die (the landing
         tiles quote a single pack), so it opens Standard only rather than
         doubling the order it advertised. */
      if (qsz.indexOf('s') === 0) { st.mode = MODE_STD; st._pinSize = true; }
      else if (qsz.indexOf('c') === 0 && comboLive()) { st.mode = MODE_COMBO; st._pinSize = true; }
      else if (!qsz && (qs.get('pack') || qs.get('labels'))) { st.mode = MODE_STD; st._pinSize = true; }
      if (qsz.indexOf('l') === 0 && sizeLive(SID_LG)) {
        st.mode = MODE_LG;
        st.sizeId = SID_LG;
        var lv = variantsFor(SID_LG)[0];
        st.material = lv ? lv.material : 'Aurora';
        st.labels[0].layout = defaultLayout(SID_LG, st.labels[0].bg);
        /* the URL wins over an old draft. Without this pin loadDraft() ran
           afterwards and put a returning visitor back on Standard, so the
           Large product's own CTA quietly sold the Standard SKU. ?pack= has
           had the same pin since it shipped; ?size= never did. */
        st._pinSize = true;
      }
      /* ?pack=<n> is the NUMBER OF PACKS (one pack = 12 labels), which is what
         the landing tiles link. ?labels=<n> is accepted too for a link that
         thinks in labels. */
      var pq = parseInt(qs.get('pack') || '', 10);
      var lq = parseInt(qs.get('labels') || '', 10);
      if (!pq && lq) pq = Math.ceil(lq / 12);
      /* ?pack=1 clamps UP to the minimum — a link never buys under it */
      if (pq > 0) { st.packs = Math.max(MIN_UNITS, Math.min(MAX_PACKS, pq)); st._pinPack = true; }
    } catch (_) {}
  })();

  function cur() { return st.labels[0]; }
  function isCombo() { return st.mode === MODE_COMBO; }
  function size() { return LT.sizeOf(st.sizeId); }
  function variant() { return variantFor(st.sizeId, st.material); }
  /* the Large line of a combo: the customer's material when the Large product
     sells it, otherwise the Large product's own stock (Aurora today). Read off
     the variants, never typed. */
  function lgComboVariant() { return variantFor(SID_LG, st.material); }
  function perPack() { var v = variant(); return v ? v.perPack : 12; }
  /* WHAT ONE UNIT OF THE STEPPER BUYS: one pack, or in combo one SET (one pack
     of each die). Every money figure on the page is built from these lines. */
  function orderLines(k) {
    if (isCombo()) {
      var a = variantFor(SID_STD, st.material), b = lgComboVariant();
      if (!a || !b) return [];
      return [{ v: a, qty: k, sizeId: SID_STD }, { v: b, qty: k, sizeId: SID_LG }];
    }
    var v = variant();
    return v ? [{ v: v, qty: k, sizeId: st.sizeId }] : [];
  }
  function labelsPerUnit() {
    return orderLines(1).reduce(function (n, L) { return n + L.v.perPack; }, 0) || perPack();
  }
  /* packs one unit adds to the discount pool — the four automatic discounts
     are scoped to BOTH lost products, so a set counts as two packs */
  function packsPerUnit() { return Math.max(1, orderLines(1).length); }
  function maxUnits() { return Math.max(1, Math.floor(MAX_PACKS / packsPerUnit())); }
  function unitWord(n) { return (isCombo() ? 'set' : 'pack') + (n === 1 ? '' : 's'); }
  function totalLabels() { return labelsPerUnit() * st.packs; }
  function layoutObj(sizeId, key) {
    var ls = LT.layoutsFor(sizeId);
    for (var i = 0; i < ls.length; i++) if (ls[i].key === key) return ls[i];
    return ls[0];
  }
  function layoutOf(t) { return layoutObj(st.sizeId, t.layout); }
  /* 'h' or 'v' for a style key — read off LT.LAYOUTS, never off the key's
     spelling. A key this die does not have is looked up on the other die, so
     a design moving between sizes keeps its axis. */
  function orientOf(key, sizeId) {
    var all = (LT && LT.LAYOUTS) || [];
    for (var i = 0; i < all.length; i++) if (all[i].key === key) return all[i].orient || 'h';
    return 'h';
  }
  function curOrient() { return orientOf(cur().layout, st.sizeId); }
  /* a style key moved to another die by name (line <-> line_lg); null when
     the other die has no twin */
  function sizeTwin(key, sizeId) {
    var keys = LT.layoutsFor(sizeId).map(function (l) { return l.key; });
    if (keys.indexOf(key) >= 0) return key;
    var m = sizeId === SID_LG ? LG_OF[key] : STD_OF[key];
    return (m && keys.indexOf(m) >= 0) ? m : null;
  }
  /* the Standard style's Large twin, BY NAME (photo -> photo_lg ... strip ->
     card_lg); anything unmapped lands on the Large die's own default */
  function lgLayoutOf(key, bgKey) {
    var keys = LT.layoutsFor(SID_LG).map(function (l) { return l.key; });
    var m = LG_OF[key];
    if (m && keys.indexOf(m) >= 0) return m;
    if (keys.indexOf(key) >= 0) return key;
    return defaultLayout(SID_LG, bgKey);
  }
  /* the derived Large design: a COPY of the customer's design with only the
     style key moved to the Large die */
  function comboLg(t) {
    var c = {};
    for (var k in t) if (Object.prototype.hasOwnProperty.call(t, k)) c[k] = t[k];
    c.layout = lgLayoutOf(t.layout, t.bg);
    return c;
  }
  function bgOf(k) {
    for (var i = 0; i < LT.BGS.length; i++) if (LT.BGS[i].key === k) return LT.BGS[i];
    var d = defaultBgKey();
    for (var j = 0; j < LT.BGS.length; j++) if (LT.BGS[j].key === d) return LT.BGS[j];
    return LT.BGS[0];
  }
  /* An ARTWORK ground is a printed picture (kind:'art'), not a foil or a
     screen: it carries `image` — the landscape plate art the seal builder
     sells — and `accent`, the colour that picture was drawn around.
     Everything the picker does differently for one hangs off this test. */
  function isArt(g) { return !!(g && g.kind === 'art'); }
  /* A ground's own colour is only worth seeding when it will read as INK. Two
     of the shop's designs declare bare white, which is the foil itself and the
     one thing the press never lays down; adopting it as an accent would quietly
     erase the accent rules from a label. Those designs keep whatever colour the
     design already carries. */
  function accentUsable(hex) {
    var m = /^#([0-9a-fA-F]{6})$/.exec(String(hex || ''));
    if (!m) return false;
    var v = parseInt(m[1], 16);
    var r = (v >> 16) & 255, g = (v >> 8) & 255, b = v & 255;
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 < 0.82;
  }

  /* ── draft persistence ──
     dataURLs are deliberately stripped: they are session preview sugar, the
     CDN URL is what survives and what production reads. Anything new and
     transient must be added to the replacer or localStorage blows its quota. */
  function saveDraft() {
    try {
      var slim = JSON.parse(JSON.stringify(st, function (k, v) {
        if (k === '_data' || k === '_upP' || k === '_saved' || k === '_editErr' ||
            k === 'thumb' || k === 'dataUrl' || k === 'uploadP' || k === 'cv' ||
            k === 'editKey' || k === '_editBad' || k === '_fit') return undefined;
        return v;
      }));
      localStorage.setItem('lt_draft', JSON.stringify(slim));
    } catch (_) {}
    /* THE EDIT LINK DIES WITH THE VISIT, NOT WITH THE DRAFT. editKey used to
       ride lt_draft, so an ABANDONED edit ("Edit labels", changed my mind,
       left") left a live line key in localStorage: the customer's next visit
       booted straight into "Update cart" and the first press removed a cart
       line nobody had asked about. sessionStorage keeps an in-visit reload
       pointing at the right line and forgets it when the tab closes. */
    try {
      if (st.editKey) sessionStorage.setItem('lt_editkey', st.editKey);
      else sessionStorage.removeItem('lt_editkey');
    } catch (_) {}
  }
  function loadDraft() {
    try {
      var ed = localStorage.getItem('lt_edit');
      if (ed) {
        localStorage.removeItem('lt_edit');     /* consumed once, always */
        var e = JSON.parse(ed);
        var payload = e && (e.lt || e.LT);
        var rows = payload && (payload.labels || []);
        if (rows && rows.length) {
          /* the variant is the die AND the material: resolve it across BOTH
             products before anything else, and say so if it has gone away
             rather than quietly rebuilding a Large label at Standard size. */
          var v = variantById(e.variantId);
          /* AN EDIT IS ALWAYS ONE LINE IN SINGLE-SIZE MODE — a combo is two
             ordinary lines and is never reconstructed from the cart */
          st.mode = MODE_STD;
          if (v) {
            st.sizeId = v.sizeId;
            st.material = v.material;
            st.mode = v.sizeId === SID_LG ? MODE_LG : MODE_STD;
          } else {
            st._editErr = 'We could not match the size and material on that cart line — ' +
              'pick them again before you add it back.';
            /* A BLOCKER, not a boot toast. variantById() resolves through
               variantsFor(), which filters on `v.available` — so this fires
               whenever the bought material is merely out of stock, and the
               update path would then DELETE the customer's Shattered Prism
               line and re-add it as Aurora at the same price. blockers()
               reads this; picking a size or a material clears it. */
            st._editBad = true;
            var wire = String(payload.size || '').toLowerCase();
            if (wire === 'lg' && sizeLive(SID_LG)) {
              st.sizeId = SID_LG; st.material = 'Aurora'; st.mode = MODE_LG;
            }
          }
          st.labels = [fromCompact(rows[0])];
          st.rush = !!e.rush;
          var n = rows.reduce(function (a, r) { return a + (r.q || 0); }, 0);
          var had = Math.round(n / (v ? v.perPack : 12)) || 1;
          /* a line bought before the minimum (or through a bare cart link)
             comes back at the minimum, and the customer is told */
          if (had < MIN_UNITS) st._minRaised = had;
          st.packs = Math.max(MIN_UNITS, Math.min(MAX_PACKS, had));
          /* MULTI-DESIGN LINES ARE NOT DESTROYED. This UI builds ONE design per
             line, so a line carrying several is loaded read-only-ish: the first
             design is restored to build from, and st.editKey is deliberately
             NOT set, so adding to cart makes a NEW line and the old one is left
             exactly as the customer bought it. */
          if (rows.length > 1) {
            st._editErr = 'That cart line carries ' + rows.length + ' different designs — ' +
              'this builder makes one label per line, so we loaded the first. Your ' +
              'existing cart line is untouched.';
          } else {
            st.editKey = e.key || '';
          }
          if (st.labels[0].lo) {
            st.logo = { name: 'logo', url: st.labels[0].lo, dataUrl: st.labels[0].lo,
                        thumb: st.labels[0].lo, w: 0, h: 0, kb: 0, note: 'saved' };
          }
          return;
        }
      }
      var d = localStorage.getItem('lt_draft');
      if (d) {
        var s = JSON.parse(d);
        if (s && s.labels && s.labels.length) {
          st.labels = [s.labels[0]];
          /* a draft written BEFORE the combo carries no `mode`: its Standard
             sizeId was the old default, not a choice, so it keeps the combo —
             only a Large draft was picked on purpose */
          if (!st._pinSize) {
            if (s.mode === MODE_COMBO || s.mode === MODE_STD || s.mode === MODE_LG) st.mode = s.mode;
            else if (s.sizeId === SID_LG) st.mode = MODE_LG;
          }
          if (!st._pinSize && s.sizeId && sizeLive(s.sizeId)) st.sizeId = s.sizeId;
          if (!st._pinSize && s.material) st.material = s.material;
          if (!st._pinPack && s.packs) st.packs = Math.max(MIN_UNITS, Math.min(MAX_PACKS, s.packs));
          st.rush = !!s.rush;
          /* never from the draft — see saveDraft(). An edit that was started
             and abandoned must not delete a cart line on a later visit. */
          try { st.editKey = sessionStorage.getItem('lt_editkey') || ''; }
          catch (_) { st.editKey = ''; }
          st.cc = s.cc || '+1';
          st._mat = s._mat || {};
          st.rightsOk = !!s.rightsOk;
          /* the dataURL was stripped on the way in; a logo that reached the
             Worker previews from its CDN url, one that never did is gone —
             which is honest, because it never existed anywhere but this tab */
          if (s.logo && s.logo.url) {
            st.logo = s.logo;
            st.logo.dataUrl = st.logo.dataUrl || s.logo.url;
            st.logo.thumb = st.logo.thumb || s.logo.url;
          }
        }
      }
    } catch (_) {}
    /* a draft written against a die or material that has since gone away must
       not survive as an unbuyable selection */
    if (!sizeLive(st.sizeId)) st.sizeId = SID_STD;
    /* the mode and the die must agree: the combo designs on Standard */
    if (st.mode === MODE_COMBO && (!comboLive() || st.editKey)) st.mode = MODE_STD;
    if (st.mode === MODE_COMBO) st.sizeId = SID_STD;
    else st.mode = st.sizeId === SID_LG ? MODE_LG : MODE_STD;
    st.packs = Math.max(MIN_UNITS, Math.min(maxUnits(), st.packs || MIN_UNITS));
    if (!variantFor(st.sizeId, st.material)) {
      var v0 = variantsFor(st.sizeId)[0];
      st.material = v0 ? v0.material : st.material;
    }
    normaliseLayouts();
    normaliseBg();
  }
  /* KEYS ARE FOREVER — 'holo' and the fifteen line-art grounds are all still
     registered, so an old draft or a cart line loads exactly as it was saved.
     This only fires on a ground that has genuinely gone away, which must not
     survive as a selection no tile in the strip can show. Seeding runs straight
     after: a first-visit label lands on the default artwork and takes that
     artwork's own colour, the way the seal builder reads defaults.color. */
  function normaliseBg() {
    var keys = bgKeys();
    st.labels.forEach(function (t) {
      if (keys.indexOf(t.bg) < 0) t.bg = defaultBgKey();
      /* A DRAFT WRITTEN BEFORE THE ARTWORK SHIPPED carries no record of whether
         its colour was chosen. Any colour that is not the house default was
         chosen — nothing else could have put it there — so an older draft's
         accent survives the first artwork the customer taps. fromCompact()
         writes the flag itself, so a cart line never reaches this line. */
      if (t._accPicked == null) {
        t._accPicked = !!(t.accent && t.accent !== ACCENTS[0]);
      }
      seedAccent(t);
    });
  }
  /* THE GROUND'S COLOUR, UNLESS THE CUSTOMER HAS ALREADY PICKED ONE. The seal
     builder writes `st.color || tpl.defaults.color`; this is the same rule with
     the customer's pick recorded on the design rather than beside it. */
  function seedAccent(t) {
    if (!t || t._accPicked) return;
    var g = bgOf(t.bg);
    if (!isArt(g) || !accentUsable(g.accent)) return;
    t.accent = g.accent;
  }
  function normaliseLayouts() {
    var keys = LT.layoutsFor(st.sizeId).map(function (l) { return l.key; });
    st.labels.forEach(function (t) {
      /* the keys are per-die (callout vs callout_lg), so a stale one is swapped
         for THIS die's default — which follows the ground, not the strip's
         first tile, or a customer on bare foil would land on the art-first
         style the moment they switched size */
      if (keys.indexOf(t.layout) < 0) {
        t.layout = sizeTwin(t.layout, st.sizeId) ||
          (LT.startLayout ? LT.startLayout(st.sizeId, orientOf(t.layout, st.sizeId))
                          : defaultLayout(st.sizeId, t.bg));
      }
    });
  }

  /* ── compact wire form <-> working form (cart property `_lt`) ──
     Empty keys are omitted; the root key is `labels`, never `tags`. Three
     downstream readers parse this: ss-cart.js, tools/render_lost.py and Label
     Farm. Drift here = preview != print. */
  function toCompact(t) {
    var o = { la: t.layout, bg: t.bg, n: t.name, q: t.q };
    if (t.hdr && t.hdr !== LT.DEFAULT_HDR) o.h = t.hdr;
    if (t.phone) o.p = t.phone;
    if (t.e164) o.e1 = t.e164;
    if (t.email) o.m = t.email;
    if (t.addr1) o.a1 = t.addr1;
    if (t.addr2) o.a2 = t.addr2;
    if (t.reward) o.r = t.reward;
    if (t.social) o.s = t.social;
    if (t.note) o.x = t.note;
    if (t.qa && t.qa !== 'none') {
      o.qa = t.qa;
      if (t.qd) o.qd = t.qd;
      if (t.qb) o.qb = t.qb;
    }
    if (t.lo) o.lo = t.lo;
    if (t.accent && t.accent !== ACCENTS[0]) o.ac = t.accent;
    return o;
  }
  function fromCompact(o) {
    o = o || {};
    /* `_accPicked` is not wire data: it records that the colour on this design
       was CHOSEN, so picking a new ground never paints over it. A record that
       carries `ac` was chosen once already (toCompact omits the house default),
       and an edit-from-cart has to bring that decision back with the colour. */
    return { layout: o.la || '', bg: o.bg || defaultBgKey(), name: o.n || '',
             hdr: o.h || '', phone: o.p || '', e164: o.e1 || '', email: o.m || '',
             addr1: o.a1 || '', addr2: o.a2 || '', reward: o.r || '', social: o.s || '',
             note: o.x || '', qa: o.qa || 'none', qd: o.qd || '', qb: o.qb || '',
             lo: o.lo || '', accent: o.ac || ACCENTS[0], _accPicked: !!o.ac,
             q: o.q || 1 };
  }
  function cfgOf(t) {
    return { layout: t.layout, bg: t.bg, hdr: t.hdr, name: t.name,
             phone: t.phone, e164: t.e164, email: t.email,
             addr1: t.addr1, addr2: t.addr2, reward: t.reward, social: t.social,
             note: t.note, qr: { action: t.qa, dest: t.qd, body: t.qb },
             logo: t._data || t.lo || '', accent: t.accent };
  }
  /* ── the empty-state proof ──
     An untouched builder has nothing to draw but the header line, and a label
     that is 90% blank foil is a poor answer to "show me what I'm buying". So
     every PREVIEW surface (the big proof and the two strips) falls back to a
     worked example until the customer types their first character — and says
     so, because calling a demo "exactly how your label will print" would be
     untrue. Nothing downstream sees this: toCompact(), probe(), fitCheck() and
     the cart payload all read cfgOf(), never pvCfg(). */
  var DEMO = { name: 'ALEX RIVERA', phone: '555 123 4567', e164: '+15551234567',
               email: 'alex@example.com' };
  function isUntouched(t) {
    return !String(t.name || '').trim() && !t.phone && !t.email && !t.social;
  }
  function pvCfg(t) {
    var c = cfgOf(t);
    if (isUntouched(t)) {
      c.name = DEMO.name; c.phone = DEMO.phone; c.e164 = DEMO.e164; c.email = DEMO.email;
    }
    return c;
  }
  function normOf(t) { return LT.norm(cfgOf(t), st.sizeId); }
  /* `sizeId` + `labels` are the combo's Large line: the same record shape,
     the Large die's wire tag and the derived design */
  function wirePayload(sizeId, labels) {
    return { v: 1, size: (sizeId ? LT.sizeOf(sizeId) : size()).wire,
             labels: (labels || st.labels).map(toCompact) };
  }

  /* ── phone: two values, always ──
     `phone` is what PRINTS, exactly as typed (a French customer typing
     06 12 34 56 78 must see that on the label). `e164` is what the code
     encodes, and it is derived — never typed. An extension is kept in the
     printed string and stripped from the code (tel: extension syntax is
     honoured inconsistently by scanner apps and it costs bytes). */
  function toE164(raw, cc) {
    var s = String(raw || '').trim();
    if (!s) return '';
    s = s.replace(/(?:\s*(?:x|ext\.?|extension|#)\s*\d+)\s*$/i, '');
    var plus = /^\+/.test(s);
    var d = s.replace(/\D/g, '');
    if (!d) return '';
    if (!plus && d.indexOf('00') === 0) { d = d.slice(2); plus = true; }
    if (plus) return '+' + d;
    var code = String(cc || '+1').replace(/\D/g, '');
    d = d.replace(/^0+/, '');                 /* national trunk prefix */
    return '+' + code + d;
  }
  function e164Ok(e) { return /^\+[1-9]\d{7,14}$/.test(String(e || '')); }
  function emailOk(m) {
    return /^[^@\s]{1,64}@[^@\s.]{1,63}(\.[^@\s.]{1,63})+$/.test(String(m || ''));
  }
  function socialOk(h) { return /^[A-Za-z0-9._]{1,30}$/.test(String(h || '')); }
  var BAD_SCHEME = /^\s*(javascript|data|vbscript|file|blob|intent|market)\s*:/i;
  function hasRoute(t) { return !!(t.phone || t.email || t.social); }

  /* ── QR state: bytes are counted on the ONE string the renderer will encode.
     Nothing here composes a payload; LT.qrPayload() is the only author. */
  function qrState(t) {
    var n = normOf(t);
    var payload = LT.qrPayload(n);
    var cap = LT.QR_BUDGET[st.sizeId] || 32;
    var bytes = payload ? LT.qrBytes(payload) : 0;
    return { payload: payload, bytes: bytes, cap: cap,
             over: bytes > cap, near: !!payload && bytes > cap - 6 && bytes <= cap,
             caption: LT.qrCaption(n), fallback: LT.qrFallback(n) };
  }

  /* ═══════════════ THE PREVIEW ═══════════════════════════════════════════ */

  var _pvT = null;
  function renderPreview() {
    var host = $('lt-pv');
    if (!host || !LT) return;
    var t = cur();
    var demo = isUntouched(t);
    LT.mount(host, pvCfg(t), { size_id: st.sizeId, upright: true, white: isWhiteStock() });
    setDims();
    host.setAttribute('aria-label', (demo ? 'Example label — ' : 'Label preview — ') +
      (demo ? '' : (t.name ? t.name + ', ' : '')) + layoutOf(t).name + ' style on ' +
      bgOf(t.bg).name + ', ' + size().label);
    /* THE COMBO SHOWS BOTH PROOFS: the buyer sees exactly what prints on each
       die, the Large one mounted from the same derived design the cart line
       carries (comboLg), never a scaled copy of the Standard art. */
    var wrap2 = $('lt-pv2'), host2 = $('lt-pv-lg');
    var cap1 = $('lt-pvcap-std'), cap2 = $('lt-pvcap-lg');
    if (wrap2) wrap2.hidden = !isCombo();
    if (cap1) cap1.hidden = !isCombo();
    if (isCombo() && host2) {
      var tl = comboLg(t), c2 = pvCfg(tl), lz = LT.sizeOf(SID_LG);
      var ll = layoutObj(SID_LG, tl.layout), lv = lgComboVariant();
      LT.mount(host2, c2, { size_id: SID_LG, upright: true, white: isWhiteStock(lv && lv.material) });
      host2.setAttribute('aria-label', (demo ? 'Example Large label — ' : 'Large label preview — ') +
        ll.name + ' style on ' + bgOf(t.bg).name + ', ' + lz.label);
      if (cap1) cap1.textContent = 'Standard · ' + size().longIn + '″ × ' + size().shortIn +
        '″ · ' + perPack() + ' per pack';
      if (cap2) cap2.textContent = 'Large · ' + lz.longIn + '″ × ' + lz.shortIn + '″ · ' +
        (lv ? lv.perPack + ' per pack' : '') + ' · same design';
    }
    var note = $('lt-pvnote');
    if (note) {
      note.textContent = demo
        ? 'Example — your own details replace this as you type.'
        : 'Live proof — this is exactly what prints.';
    }
  }
  function schedulePreview() {
    /* mounting is cheap, but a fast typist repaints on every keystroke and the
       fit pass forces layout each time */
    clearTimeout(_pvT);
    _pvT = setTimeout(renderPreview, 90);
  }
  function setDims() {
    var z = LT.sizeOf(st.sizeId);
    var lo = String(z.longIn), sh = String(z.shortIn);
    /* both dies are cut landscape; a VERTICAL style is previewed standing up,
       so its rulers swap — the tall one carries the long edge */
    var up = orientOf(cur().layout, st.sizeId) === 'v';
    var dw = $('lt-dim-w'), dh = $('lt-dim-h');
    if (dw) dw.innerHTML = (up ? sh : lo) + '&Prime;';
    if (dh) dh.innerHTML = (up ? lo : sh) + '&Prime;';
    var pd = $('lt-pvdims');
    if (pd) pd.textContent = 'Printed size: ' + lo + ' by ' + sh + ' inches' +
      (up ? ', applied on end' : '');
  }
  /* the box animates height between frames so a die or style change does not
     shove the page; the fade drives .pvmeas so the dim labels travel WITH the
     label instead of snapping beside it */
  function glideBox(box, h0) {
    box.style.transition = 'none';
    box.style.height = '';
    var h1 = box.offsetHeight;
    if (Math.abs(h1 - h0) < 2) { box.style.transition = ''; return; }
    if (box._gt) clearTimeout(box._gt);
    box.style.height = h0 + 'px';
    void box.offsetHeight;
    box.style.transition = 'height .38s ease';
    box.style.height = h1 + 'px';
    box._gt = setTimeout(function () {
      box.style.transition = '';
      box.style.height = '';
      box._gt = null;
    }, 430);
  }
  function pvFade(run) {
    var pv = $('lt-pv');
    var box = document.querySelector('#lt-pvpane .pvbox');
    var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!pv || rm) { run(); return; }
    var pvm = pv.closest('.pvmeas') || pv;
    var pv2 = $('lt-pv2');
    var h0 = box ? box.offsetHeight : 0;
    pvm.style.opacity = '0';
    if (pv2) pv2.style.opacity = '0';
    setTimeout(function () {           /* full fade-out before the swap */
      try { run(); } catch (_) {}
      pvm.style.opacity = '1';
      if (pv2) pv2.style.opacity = '1';
      if (box) { try { glideBox(box, h0); } catch (_) {} }
    }, 200);
  }

  /* ═══════════════ SIZE ══════════════════════════════════════════════════ */

  /* THREE WAYS TO BUY, ONE ROW (owner 2026-09-28: "do the combo default").
     COMBO leads and is pre-selected; STANDARD ONLY and LARGE ONLY sit under
     it and behave exactly as the two size cards always did. Every price on a
     card is the variants' own (a combo card is the Standard pack plus the
     Large pack, added), never a typed figure. No card claims popularity. */
  function modeRows() {
    var zs = LT.SIZES[SID_STD], zl = LT.SIZES[SID_LG];
    var vs = variantFor(SID_STD, st.material) || variantsFor(SID_STD)[0];
    var vl = variantFor(SID_LG, st.material) || variantsFor(SID_LG)[0];
    return [
      /* every card quotes its MINIMUM order (MIN_UNITS of its unit) — the
         combo's is the page's default, 2 sets */
      { mode: MODE_COMBO, title: 'COMBO',
        dim: (vs ? vs.perPack : 12) * MIN_UNITS + ' small + ' +
             (vl ? vl.perPack : 12) * MIN_UNITS + ' large',
        sub: 'One design on both sizes — for bags + gear',
        price: (vs && vl) ? money((vs.cents + vl.cents) * MIN_UNITS) + ' / ' +
          (vs.perPack + vl.perPack) * MIN_UNITS + ' labels' : '',
        live: comboLive(), lock: !!st.editKey },
      { mode: MODE_STD, size: SID_STD, title: 'STANDARD ONLY',
        dim: zs.longIn + '″ × ' + zs.shortIn + '″',
        sub: 'Fits a bag tag, a laptop lid, a bottle',
        price: vs ? money(vs.cents * MIN_UNITS) + ' / ' + vs.perPack * MIN_UNITS + ' labels' : '',
        live: sizeLive(SID_STD) },
      { mode: MODE_LG, size: SID_LG, title: 'LARGE ONLY',
        dim: zl.longIn + '″ × ' + zl.shortIn + '″',
        sub: 'Bigger type — room for an address',
        price: vl ? money(vl.cents * MIN_UNITS) + ' / ' + vl.perPack * MIN_UNITS + ' labels' : '',
        live: sizeLive(SID_LG) }
    ];
  }
  function renderSizeCards() {
    var host = $('lt-size-pick');
    if (!host) return;
    host.innerHTML = modeRows().map(function (r) {
      var on = st.mode === r.mode;
      var off = !r.live || r.lock;
      return '<button type="button" class="ss-size-card' +
        (r.mode === MODE_COMBO ? ' lt-combo-card' : '') + '" role="radio" data-mode="' +
        r.mode + '"' + (r.size ? ' data-size="' + r.size + '"' : '') +
        ' aria-checked="' + (on ? 'true' : 'false') + '"' +
        (off ? ' aria-disabled="true"' : '') + '>' +
        (r.live ? '' : '<span class="soon">SOLD OUT</span>') +
        '<b>' + r.title + '</b>' +
        '<span class="dim">' + esc(r.dim) + '</span>' +
        '<span class="sub">' + esc(r.lock
          ? 'You are editing one cart line — pick one size' : r.sub) + '</span>' +
        (r.price ? '<span class="sub lt-cardprice">' + esc(r.price) + '</span>'
                 : '<span class="sub">Not on sale right now</span>') +
        '</button>';
    }).join('');
    host.querySelectorAll('.ss-size-card').forEach(function (c) {
      c.onclick = function () { applyMode(c.getAttribute('data-mode')); };
    });
  }

  /* Switching die switches PRODUCT: the layout set, the QR budget, the
     material list and the price all change with it, and a Shattered Prism
     selection may not survive a switch to Large (there is one large-die press
     and it runs Aurora). Switching back restores the picker. The combo designs
     on the Standard die, so Combo <-> Standard only keeps every choice made. */
  function applyMode(mode) {
    if (mode !== MODE_COMBO && mode !== MODE_STD && mode !== MODE_LG) return;
    if (mode === st.mode) return;
    if (mode === MODE_COMBO) {
      if (!comboLive()) { toast('The combo is not on sale right now', true); return; }
      if (st.editKey) {
        toast('You are editing one cart line — pick Standard or Large for it', true);
        return;
      }
    }
    var id = mode === MODE_LG ? SID_LG : SID_STD;
    if (!sizeLive(id)) {
      toast('That size is not on sale right now', true);
      return;
    }
    /* remember the material per die: a customer who chose Shattered Prism,
       looked at Large (which is Aurora only) and came back must land back on
       Prism, not be quietly switched */
    st._mat = st._mat || {};
    st._mat[st.sizeId] = st.material;
    pvFade(function () {
      st.mode = mode;
      st.sizeId = id;
      var v = variantFor(id, st._mat[id] || st.material);
      if (!v) v = variantFor(id, st.material);
      if (!v) v = variantsFor(id)[0];
      st.material = v ? v.material : st.material;
      st._editBad = false;          /* the customer just re-picked the die */
      if (st.packs > maxUnits()) st.packs = maxUnits();
      if (st.packs < MIN_UNITS) st.packs = MIN_UNITS;
      /* the layout keys are per-die (callout vs callout_lg), so a stale key
         has to be swapped for this die's first style */
      normaliseLayouts();
      paintRootMode();
      renderSizeCards();
      renderLayouts();
      renderBgCarousel();
      renderMaterial();
      renderQtiers();
      renderQr();                 /* the byte budget moved with the die */
      setDims();
      renderPreview();
      sync();
    });
    _refocus('#lt-size-pick .ss-size-card[aria-checked="true"]', 24);
  }
  function applySize(id) { applyMode(id === SID_LG ? MODE_LG : MODE_STD); }
  function paintRootMode() {
    var root = $('lt-root');
    if (!root) return;
    root.classList.toggle('lt-size-lg', st.sizeId === SID_LG);
    root.classList.toggle('lt-combo', isCombo());
  }
  window.LT_applySize = applySize;
  window.LT_applyMode = applyMode;

  /* ═══════════════ STYLE (the seal's shape row) ══════════════════════════ */

  /* THE ORIENTATION SWITCH sits over the style strip: two buttons, each with
     a small drawn label shape, and the strip below lists only that axis. */
  function renderOrient() {
    var strip = $('lt-laycar');
    if (!strip || !LT.pickerLayouts) return;
    var host = $('lt-orient');
    if (!host) {
      host = document.createElement('div');
      host.id = 'lt-orient';
      host.className = 'lt-orient';
      host.setAttribute('role', 'radiogroup');
      host.setAttribute('aria-label', 'Label orientation');
      strip.parentNode.insertBefore(host, strip);
    }
    var now = curOrient();
    host.innerHTML = [['h', 'Horizontal'], ['v', 'Vertical']].map(function (o) {
      var on = now === o[0];
      return '<button type="button" role="radio" data-or="' + o[0] + '" aria-checked="' +
        (on ? 'true' : 'false') + '" class="lt-or' + (on ? ' on' : '') + '">' +
        '<span class="lt-or-ic lt-or-' + o[0] + '" aria-hidden="true"></span>' + o[1] + '</button>';
    }).join('');
    host.querySelectorAll('.lt-or').forEach(function (b) {
      b.onclick = function () {
        var want = b.getAttribute('data-or');
        if (curOrient() === want) return;
        pvFade(function () {
          var t = cur(), keys = LT.pickerLayouts(st.sizeId, want).map(function (l) { return l.key; });
          var twin = ORIENT_TWIN[t.layout];
          t.layout = (twin && keys.indexOf(twin) >= 0) ? twin : LT.startLayout(st.sizeId, want);
          renderLayouts();
          renderQr();          /* qrActions / qr:false differ per style */
          sync();
        });
        _refocus('#lt-orient .lt-or.on', 24);
      };
    });
  }
  /* the styles the strip offers: the picker's set on the current axis, plus
     the design's own style if it is an older one (a cart line being edited
     must show what it was bought with, selected, not silently swap it) */
  function stripLayouts() {
    if (!LT.pickerLayouts) return LT.layoutsFor(st.sizeId);
    var list = LT.pickerLayouts(st.sizeId, curOrient()).slice();
    var mine = layoutObj(st.sizeId, cur().layout);
    if (mine && mine.key === cur().layout && list.indexOf(mine) < 0) list.unshift(mine);
    return list;
  }
  function renderLayouts() {
    var host = $('lt-laycar');
    if (!host) return;
    renderOrient();
    host.innerHTML = '';
    host.classList.toggle('lt-vert', curOrient() === 'v');
    stripLayouts().forEach(function (l) {
      var on = cur().layout === l.key;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sqk-b' + (on ? ' on' : '');
      b.setAttribute('data-lay', l.key);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', l.name + ' style');
      b.innerHTML = '<span class="sqk-ic" aria-hidden="true">' +
        '<span class="lt-tag"></span></span><i>' + esc(l.name) + '</i>';
      /* the mini is a REAL proof of the customer's own label in that style, so
         a style that would drop a filled line is visible before it is chosen */
      var c = pvCfg(cur());
      c.layout = l.key;
      try { LT.mount(b.querySelector('.lt-tag'), c, { size_id: st.sizeId, upright: true }); } catch (_) {}
      b.onclick = function () {
        if (cur().layout === l.key) return;
        pvFade(function () {
          cur().layout = l.key;
          renderLayouts();
          renderQr();          /* qrActions / qr:false differ per style */
          sync();
        });
        _refocus('#lt-laycar .sqk-b.on', 24);
      };
      host.appendChild(b);
    });
    paintLayNote();
  }
  /* Re-mount the minis IN PLACE — the tiles themselves are not rebuilt, so the
     strip keeps its scroll position and a focused tile keeps focus while the
     customer types. Debounced, because each repaint is 14 mounts. */
  var _stripT = null;
  function scheduleStripMinis() {
    clearTimeout(_stripT);
    _stripT = setTimeout(repaintStripMinis, 420);
  }
  function repaintStripMinis() {
    var t = cur();
    document.querySelectorAll('#lt-laycar .sqk-b').forEach(function (b) {
      var host = b.querySelector('.lt-tag');
      if (!host) return;
      var c = pvCfg(t);
      c.layout = b.getAttribute('data-lay');
      try { LT.mount(host, c, { size_id: st.sizeId, upright: true, white: isWhiteStock() }); } catch (_) {}
    });
    /* ARTWORK TILES CARRY NO TYPE, so nothing typed can change one — and
       re-mounting twenty-eight of them on every keystroke burst would rebuild
       twenty-eight <image> elements for pictures that have not moved. The foil
       and colour tiles do show the header and the name, so they repaint. */
    document.querySelectorAll('#lt-bgcar .bgcar-t:not(.bgcar-art)').forEach(function (b) {
      var host = b.querySelector('.lt-tag');
      if (host) mountBgMini(host, b.getAttribute('data-bg'));
    });
  }

  /* FIXED-HEIGHT one-liner (.sqk-note{min-height:30px}) precisely so this line
     changing cannot walk the page. */
  var _noteT = null;
  function scheduleLayNote() {
    clearTimeout(_noteT);
    _noteT = setTimeout(paintLayNote, 260);
  }
  /* the long honesty note lives UNDER THE CTA, beside the blocker it explains
     — never in the pane. In the pane it grew to three or four lines between
     the STYLE strip and the BACKGROUND heading and shoved the whole carousel
     down the page every time a field changed; .sqk-note exists precisely so
     that strip cannot reflow. The pane keeps the one-line summary. */
  function layWarnBox() {
    var warn = $('lt-lay-warn');
    if (warn) return warn;
    var buy = $('lt-buy'), n = $('lt-lay-note');
    if (!buy && !n) return null;
    warn = document.createElement('div');
    warn.id = 'lt-lay-warn';
    warn.className = 'lt-note';
    warn.hidden = true;
    if (buy) buy.appendChild(warn);
    else n.parentNode.insertBefore(warn, n.nextSibling);
    return warn;
  }
  /* THE ART-FIRST STYLE'S LINE IS ABOUT A PICTURE, and on a foil or a colour
     there is none. plateBox() draws nothing without an artwork (k.plate is
     false on every other ground), so 'Big Picture' on Black is the name and
     the number set large on the bare material — no picture, and no panel
     either. That state is TWO TAPS away: the art-first style leads the strip
     and opens selected on the default artwork, and picking a foil next leaves
     it selected. So the line under the strip describes the ground the customer
     is actually standing on.

     Only this sentence moves. The style keeps its key, its name and every byte
     of its geometry, LT.LAYOUTS' own note stays true for the ground the style
     was composed for, and the customer's pick is never second-guessed —
     switching the ground has to be free, and a style that re-picked itself
     could drop a line they had already typed. */
  function layNote(lay) {
    if (!lay) return '';
    if (lay.photo && !isArt(bgOf(cur().bg)))
      return 'Your name and number, large, on the material';
    return lay.note || '';
  }
  function paintLayNote() {
    var n = $('lt-lay-note');
    if (!n) return;
    var lay = layoutOf(cur());
    /* honesty over silence: name every FILLED field this style has no room
       for — measured on a real mount of THIS design, not on the style's
       declaration — and where it does print. One probe, both answers. */
    var msgs = [], shorts = [];
    var miss = probe(function (mountOne) {
      var m = droppedFields(cur(), lay, mountOne);
      return { m: m, where: m.length
        ? carriersFor(m.map(function (x) { return x.key; }), cur(), mountOne) : '' };
    });
    if (miss.m.length) {
      var fields = andList(miss.m.map(function (x) { return x.label; }));
      msgs.push('The ' + lay.name + ' style has no room for the ' + fields +
        ' — ' + miss.where + '.');
      shorts.push('No room for the ' + fields + '.');
    }
    if ((cur().lo || cur()._data) && lay.logo === false) {
      msgs.push('The ' + lay.name + ' style has no logo slot — your logo prints on the others.');
      shorts.push('No logo slot.');
    }
    /* THE COMBO'S LARGE LABEL IS MEASURED TOO — the same probe on the derived
       design at the Large die, so a line the Large twin cannot carry is named
       here in the same words, not discovered at the press */
    if (isCombo()) {
      var tl = comboLg(cur()), ll = layoutObj(SID_LG, tl.layout);
      var lm = probe(function (mountOne) { return droppedFields(tl, ll, mountOne); }, SID_LG);
      if (lm.length) {
        var lf = andList(lm.map(function (x) { return x.label; }));
        msgs.push('On the Large label, the ' + ll.name + ' style has no room for the ' + lf +
          ' — pick another style, or choose Standard only.');
        shorts.push('Large label: no room for the ' + lf + '.');
      }
    }
    if (cur().qa !== 'none') {
      if (!lay.qr) {
        msgs.push('The ' + lay.name + ' style prints no code. Pick another style to keep it.');
        shorts.push('Prints no code.');
      } else if (lay.qrActions && lay.qrActions.indexOf(cur().qa) < 0) {
        msgs.push('The ' + lay.name + ' style carries a Call, Text or WhatsApp code only.');
        shorts.push('Call, Text or WhatsApp codes only.');
      }
    }
    var full = msgs.join(' ');
    /* the pane's line: FIXED height (.sqk-note), two lines, clamped. The style
       description is what it says when there is nothing to warn about. */
    n.textContent = shorts.length ? shorts.join(' ') : layNote(lay);
    n.className = 'sqk-note' + (shorts.length ? ' warn' : '');
    if (full) n.title = full; else n.removeAttribute('title');
    var warn = layWarnBox();
    if (warn) {
      warn.textContent = full;
      warn.hidden = !msgs.length;
      /* A DEAD END NEEDS A DOOR. When no style on this die can print every
         line the customer typed, naming the blocker is not enough — the QR
         over-budget path has offered the bigger die since it shipped, and this
         is the same problem with the same answer. carriersFor() opens with
         'it prints on ' when it DID find a style; anything else is the
         nothing-fits fallback. Its own id, because #lt-golarge may already be
         on screen under the byte meter. */
      if (msgs.length && miss.m.length &&
          String(miss.where).indexOf('it prints on ') !== 0 &&
          st.sizeId !== SID_LG && sizeLive(SID_LG)) {
        offerLarge(warn, 'lt-golarge-fit');
      }
    }
  }

  /* ═══════════════ BACKGROUND CAROUSEL ═══════════════════════════════════ */

  /* THE TILE ANSWERS ONE QUESTION, AND WHICH QUESTION DEPENDS ON THE GROUND.
     For a foil or a colour it is "what is the material under my type?" — a
     whole label at 66-88px is ~30px tall, and at that size Open Holo, Silver,
     Prismatic and Navy are the same tile — so the mini keeps the header and
     the name, drops everything else (code, reward, address, social, extra line,
     logo), and the CSS crops it to the seal's own 54px tile height, which puts
     the ground at about twice the scale.
     For an ARTWORK ground the question is "which picture?", and the seal
     builder answers that with the picture and nothing else. So every line is
     stripped: the tile is the artwork at ~2x rather than a shrunken label with
     a foil plate laid across the middle of it. The proof above the strip is
     always the whole label, so nothing is hidden by this. */
  function bgMiniCfg(key, asPicture) {
    var c = pvCfg(cur());
    var g = bgOf(key);
    c.bg = key;
    if (LT.startLayout && orientOf(c.layout, st.sizeId) === 'v') c.layout = LT.startLayout(st.sizeId, 'h');
    c.email = ''; c.addr1 = ''; c.addr2 = ''; c.reward = '';
    c.social = ''; c.note = ''; c.logo = '';
    c.qr = { action: 'none', dest: '', body: '' };
    if (asPicture) {
      /* a LONE SPACE is the renderer's "print no header" (norm()); '' would
         print the default line back */
      c.hdr = ' '; c.name = ''; c.phone = ''; c.e164 = '';
      if (accentUsable(g.accent)) c.accent = g.accent;
    }
    return c;
  }
  /* TILE-SIZED ART, NOT PRESS-SIZED ART. The <image> the renderer writes points
     at the full plate file (~75 KB each): twenty-eight of those behind one
     picker is two megabytes of pictures nobody is looking at closely, most of
     them below the fold. Shopify's CDN resizes on the query string, so a tile
     asks for a tile-sized copy of the SAME asset while the proof above keeps
     the full one. Only the ground's own href is touched, and only when it is a
     CDN url we can size — anything else is left exactly as written. */
  function shrinkArt(svg, g) {
    if (!svg || !g || !g.image) return;
    if (!/^https:\/\/cdn\.shopify\.com\//i.test(g.image)) return;
    var XL = 'http://www.w3.org/1999/xlink';
    var small = g.image + (g.image.indexOf('?') < 0 ? '?' : '&') + 'width=220';
    var im = svg.querySelectorAll('image');
    for (var i = 0; i < im.length; i++) {
      var h = im[i].getAttribute('href');
      if (!h) { try { h = im[i].getAttributeNS(XL, 'href'); } catch (_) { h = ''; } }
      if (h !== g.image) continue;
      im[i].setAttribute('href', small);
      try { im[i].setAttributeNS(XL, 'href', small); } catch (_) {}
    }
  }
  /* THE PLATE COMES OFF THE TILE. An artwork ground asks every layout for a
     bare-foil plate under the type, and on the standard callout that panel runs
     1.1-43.9 mm of a 44.958 mm die: exactly right on the label, where a phone
     number has to be readable over a picture, and useless in an 84px tile,
     where it would leave twenty-eight grounds looking like twenty-eight
     identical foil rectangles with a coloured hairline round them. So the tile
     mounts the REAL renderer, then lifts the plate out (it marks itself
     data-lt-plate) along with the hairlines that were holding type that is no
     longer there — the same thing the seal builder's tiles show, which is the
     artwork and nothing else. The proof above the strip is the whole label,
     plate included, so nothing about the print is being hidden here.
     If a future renderer stops marking the plate, no node is found and the tile
     falls back to the type-carrying mini rather than showing a blank panel. */
  function stripFurniture(svg) {
    var i, p = svg.querySelectorAll('[data-lt-plate]');
    for (i = 0; i < p.length; i++) {
      if (p[i].parentNode) p[i].parentNode.removeChild(p[i]);
    }
    /* ...and the hairlines with it. The accent rule under the header line runs
       the width of the label, and with the type and the plate gone it reads as
       a scratch across the picture rather than as trim. Every rule this file
       draws is a stroked path with NO fill attribute (accent rule, column seam,
       band flash); the die's print-safe keyline carries fill="none" and stays,
       because it is what says a tile is a label and not a photograph. */
    var h = svg.querySelectorAll('path[stroke]:not([fill])');
    for (i = 0; i < h.length; i++) {
      if (h[i].parentNode) h[i].parentNode.removeChild(h[i]);
    }
    return p.length;
  }
  /* mount() sizes the SVG to the host WIDTH (height:auto), which in a 54px box
     leaves a 30px label floating in dark bands. `slice` is SVG's own
     object-fit:cover — the viewBox is scaled until it COVERS the element box
     and the overflow is clipped — and xMin keeps the left edge, which is where
     the header and the name sit. Filling the box by hand instead (width:auto
     on an element with a viewBox) does NOT work: the width resolves to 100% of
     the container and the drawing is letterboxed inside it. */
  function mountBgMini(host, key) {
    var g = bgOf(key), art = isArt(g), r = null;
    try { r = LT.mount(host, bgMiniCfg(key, art), { size_id: st.sizeId }); }
    catch (_) { r = null; }
    /* THE PICTURE MOUNT HAS TO EARN ITSELF. It counts only if it rendered AND a
       plate came off it; a mount that threw, or one with no plate to lift,
       would leave a bare foil panel where the artwork should be. Either way the
       tile falls back to the type-carrying mini, which works on every ground. */
    if (art && !(r && r.svg && stripFurniture(r.svg))) {
      art = false;
      try { r = LT.mount(host, bgMiniCfg(key, false), { size_id: st.sizeId }); }
      catch (_) { return; }
    }
    if (!r || !r.svg) return;
    try {
      r.svg.style.height = '100%';
      /* xMin holds the left edge, which is where the header and the name sit —
         an artwork tile has no type to hold, so it is centred the way a picture
         wants to be */
      r.svg.setAttribute('preserveAspectRatio',
        art ? 'xMidYMid slice' : 'xMinYMid slice');
      shrinkArt(r.svg, g);
    } catch (_) {}
  }

  /* THE ARTWORK LEADS (owner 2026-09-05). LT.BGS arrives in picker order — the
     shop's own designs first, then the foils, the colours and the plates — and
     the strip renders it verbatim, one tile per ground and nothing else in
     between that could be mistaken for one (tools/lt_builder_check.py asserts
     the two lists match key for key). The only extra furniture is the group
     rule where the artwork ends: a hairline in the phone strip, where a heading
     would cost a tile's width, and the heading itself once the strip becomes a
     grid. There is still NO "upload your own backdrop" tile on this product. */
  var BG_GROUPS = { art: 'Designs', plain: 'Foil & colour' };
  function renderBgCarousel() {
    var host = $('lt-bgcar');
    if (!host) return;
    host.innerHTML = '';
    var group = '';
    /* LESS INK (owner 2026-09-30: "use less ink no dark bgs"). The strip shows
       LT.pickerGrounds() — bare stock, the eight light artworks and the light
       drawn grounds; the dark artworks, the colour screens and the ink plates
       stay renderable for every design already sold with one. A design being
       edited that sits on one of those keeps it, shown first and selected. */
    var shown = LT.pickerGrounds ? LT.pickerGrounds().slice() : LT.BGS.slice();
    var mineG = bgOf(cur().bg);
    if (mineG && mineG.key === cur().bg && shown.indexOf(mineG) < 0) shown.unshift(mineG);
    shown.forEach(function (g) {
      var kind = isArt(g) ? 'art' : 'plain';
      if (kind !== group) {
        group = kind;
        var sep = document.createElement('div');
        sep.className = 'bgcar-sep';
        sep.setAttribute('role', 'presentation');
        sep.setAttribute('aria-hidden', 'true');
        if (!host.firstChild) sep.setAttribute('data-first', '1');
        sep.innerHTML = '<span>' + esc(BG_GROUPS[kind]) + '</span>';
        host.appendChild(sep);
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bgcar-t' + (kind === 'art' ? ' bgcar-art' : '');
      b.setAttribute('data-bg', g.key);
      b.setAttribute('role', 'option');
      b.setAttribute('aria-selected', 'false');
      b.setAttribute('aria-label', g.name + ' background');
      b.innerHTML = '<span class="lt-tag"></span><i>' + esc(g.name) + '</i>';
      mountBgMini(b.querySelector('.lt-tag'), g.key);
      b.onclick = function () {
        if (cur().bg === g.key) return;
        pvFade(function () {
          cur().bg = g.key;
          seedAccent(cur());     /* the design's own colour, unless one is picked */
          /* bgcarPaint(), NOT renderBgCarousel(): the tiles do not depend on
             which one is chosen, and rebuilding the strip would re-mount
             fifty-three labels (twenty-eight of them with a picture in) to move
             one ring. sync() repaints the foil minis on its own debounce. */
          bgcarPaint();
          paintAccentRow();      /* ...and the swatch row says so */
          sync();
        });
        _refocus('#lt-bgcar .bgcar-t.on', 24);
      };
      host.appendChild(b);
    });
    paintBgMore();
    bgcarPaint();
  }
  /* FIFTY-THREE GROUNDS DO NOT FIT ON A DESKTOP PAGE. On a phone the strip is a
     carousel and length costs nothing but swipes; at 1040px and up
     ss-builder.css turns the same element into a wrapping grid, where every
     ground at once is eleven rows of pictures wedged between the style row and
     the fields. So the grid opens four rows deep with the rest one press away.
     The button only exists at that width — the phone strip is never clipped. */
  function bgMoreBtn() {
    var host = $('lt-bgcar');
    if (!host) return null;
    var b = $('lt-bgmore');
    if (b) return b;
    b = document.createElement('button');
    b.type = 'button';
    b.id = 'lt-bgmore';
    b.className = 'bgcar-more';
    b.setAttribute('aria-controls', 'lt-bgcar');
    b.onclick = function () {
      host.classList.toggle('bgcar-open', !host.classList.contains('bgcar-open'));
      paintBgMore();
    };
    /* after the strip, or after the wrapper wireStripMouse() puts around it */
    var anchor = host.parentNode &&
      host.parentNode.classList && host.parentNode.classList.contains('carwrap')
      ? host.parentNode : host;
    if (anchor.parentNode) anchor.parentNode.insertBefore(b, anchor.nextSibling);
    return b;
  }
  function paintBgMore() {
    var host = $('lt-bgcar'), b = bgMoreBtn();
    if (!host || !b) return;
    var open = host.classList.contains('bgcar-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = open ? 'Show fewer backgrounds'
      : 'Show all ' + host.querySelectorAll('.bgcar-t').length + ' backgrounds';
  }
  function bgcarPaint() {
    var host = $('lt-bgcar');
    if (!host || !host.firstChild) return;
    var on = null;
    host.querySelectorAll('.bgcar-t').forEach(function (b) {
      var hit = b.getAttribute('data-bg') === cur().bg;
      b.classList.toggle('on', hit);
      b.setAttribute('aria-selected', hit ? 'true' : 'false');
      if (hit) on = b;
    });
    /* A SELECTION THE CLIP IS HIDING OPENS THE GRID. A picker with no highlight
       anywhere on it reads as nothing selected, and the desktop clip can put a
       chosen ground four rows below the fold. Phones never reach this: the
       strip scrolls sideways, so it has no height to overflow. */
    if (on && host.scrollHeight > host.clientHeight + 4) {
      /* MEASURED IN VIEWPORT COORDINATES, not offsetTop: .bgcar is not
         positioned, so a tile's offsetParent is some ancestor of the whole pane
         and offsetTop counts from there — which made every selection look like
         it was below the clip and opened the grid on load. */
      var hr = host.getBoundingClientRect(), tr = on.getBoundingClientRect();
      if (tr.bottom > hr.bottom + 1) {
        host.classList.add('bgcar-open');
        paintBgMore();
      }
    }
    /* keep the selection centred — but never yank a keyboard user's focused
       tile out from under them */
    if (on && document.activeElement !== on) {
      var left = Math.max(0, on.offsetLeft - (host.clientWidth - on.offsetWidth) / 2);
      try {
        host.scrollTo({ left: left, behavior:
          matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      } catch (_) { host.scrollLeft = left; }
    }
  }

  /* ═══ mouse access for the two strips ═══════════════════════════════════
     Hover + fine-pointer devices only — touch already swipes. Arrows page the
     strip, a vertical wheel scrolls it sideways, and the strip drags like a
     swipe; a drag that actually moved swallows the click in the CAPTURE phase
     so releasing over a tile never selects it. Everything binds to the strip
     HOSTS, which survive every innerHTML repaint. */
  function wireStripMouse() {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    ['lt-laycar', 'lt-bgcar'].forEach(function (id) {
      var strip = $(id);
      if (!strip || strip._mousy) return;
      strip._mousy = true;
      var wrap = document.createElement('div');
      wrap.className = 'carwrap';
      strip.parentNode.insertBefore(wrap, strip);
      wrap.appendChild(strip);
      var arr = {};
      [['l', -1, 'Scroll backwards'], ['r', 1, 'Scroll forwards']].forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'car-arr ' + a[0];
        b.setAttribute('aria-label', a[2]);
        b.innerHTML = a[0] === 'l' ? '‹' : '›';
        b.onclick = function () {
          strip.scrollBy({ left: a[1] * Math.round(strip.clientWidth * 0.8),
                           behavior: 'smooth' });
        };
        wrap.appendChild(b);
        arr[a[0]] = b;
      });
      function paintArrows() {
        var max = strip.scrollWidth - strip.clientWidth;
        arr.l.hidden = max < 8 || strip.scrollLeft < 8;
        arr.r.hidden = max < 8 || strip.scrollLeft > max - 8;
      }
      strip.addEventListener('scroll', paintArrows, { passive: true });
      addEventListener('resize', paintArrows);
      new MutationObserver(paintArrows).observe(strip, { childList: true });
      paintArrows();
      strip.addEventListener('wheel', function (e) {
        if (strip.scrollWidth - strip.clientWidth < 8) return;
        var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
        if (!d) return;
        strip.scrollLeft += d;
        e.preventDefault();
      }, { passive: false });
      var dn = null;
      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dn = { x: e.clientX, sl: strip.scrollLeft, moved: false, id: e.pointerId };
      });
      strip.addEventListener('pointermove', function (e) {
        if (!dn) return;
        var dx = e.clientX - dn.x;
        if (!dn.moved && Math.abs(dx) > 4) {
          dn.moved = true;
          strip.classList.add('dragging');
          try { strip.setPointerCapture(dn.id); } catch (_) {}
        }
        if (dn.moved) strip.scrollLeft = dn.sl - dx;
      });
      function dragEnd() {
        if (!dn) return;
        var was = dn.moved;
        dn = null;
        strip.classList.remove('dragging');
        if (was) {
          strip._swallow = true;
          setTimeout(function () { strip._swallow = false; }, 80);
        }
      }
      strip.addEventListener('pointerup', dragEnd);
      strip.addEventListener('pointercancel', dragEnd);
      strip.addEventListener('click', function (e) {
        if (strip._swallow) { e.stopPropagation(); e.preventDefault(); }
      }, true);
    });
  }

  /* ═══════════════ YOUR DETAILS ══════════════════════════════════════════ */

  function field(id, label, inner, hint, cnt) {
    return '<div class="field" id="fw-' + id + '">' +
      '<label for="' + id + '">' + label + (cnt || '') + '</label>' + inner +
      (hint ? '<div class="hint" id="' + id + '-hint">' + hint + '</div>' : '') +
      '<div class="err" id="' + id + '-err" role="alert" hidden></div></div>';
  }
  function cntSpan(id) { return '<span class="cnt" id="' + id + '-cnt"></span>'; }
  function inputHtml(id, val, o) {
    o = o || {};
    return '<input type="' + (o.type || 'text') + '" id="' + id + '" value="' + esc(val) + '"' +
      ' maxlength="' + (o.cap || 40) + '"' +
      (o.im ? ' inputmode="' + o.im + '"' : '') +
      (o.ph ? ' placeholder="' + esc(o.ph) + '"' : '') +
      (o.cls ? ' class="' + o.cls + '"' : '') +
      ' autocomplete="' + (o.ac || 'off') + '" spellcheck="false">';
  }
  function paintCnt(id, cap) {
    var c = $(id + '-cnt'), el = $(id);
    if (!c || !el) return;
    var n = el.value.length;
    c.textContent = n + '/' + cap;
    c.className = 'cnt' + (n >= cap ? ' over' : (n > cap - 4 ? ' warn' : ''));
  }
  function err(id, msg) {
    var e = $(id + '-err');
    if (!e) return;
    e.textContent = msg || '';
    e.hidden = !msg;
  }
  function bindField(id, key, cap, after) {
    var el = $(id);
    if (!el) return;
    el.oninput = function () {
      cur()[key] = el.value.slice(0, cap);
      paintCnt(id, cap);
      if (after) after(cur(), el);
      sync();
    };
    /* the sticky bar must never sit on a focused input */
    el.onfocus = function () {
      setTimeout(function () {
        try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) {}
      }, 250);
    };
    paintCnt(id, cap);
  }

  /* the printed-amount warning, toggled in place. The details card is never
     rebuilt by sync() (it would take the focus out of the field being typed
     in), so anything that has to react to a keystroke inside it is a hidden
     element that gets shown — not a line pushed during a rebuild. */
  function paintRewardNote() {
    var el = $('lt-reward-note');
    if (el) el.hidden = !/[$£€]|\d\d/.test(cur().reward || '');
  }

  /* THE DESIGN'S OWN COLOUR IS AN OPTION, NOT A REPLACEMENT. Every artwork was
     drawn around one accent, so while an artwork ground is selected that colour
     is offered — at the END of the row, after the eight house colours, so the
     row nobody has touched does not renumber itself under a customer's finger
     (or under the harness, which counts swatches by position). It appears only
     when the artwork's colour is not already one of the eight. */
  function swHtml(hex, on, label) {
    return '<button type="button" class="sw" data-acc="' + esc(hex) +
      '" style="background:' + esc(hex) + '" aria-pressed="' + (on ? 'true' : 'false') +
      '" aria-label="' + esc(label) + '"></button>';
  }
  function accentRowHtml(t) {
    var o = [], seen = {};
    ACCENTS.forEach(function (a) {
      seen[a.toLowerCase()] = 1;
      o.push(swHtml(a, t.accent === a, 'Accent ' + a));
    });
    var g = bgOf(t.bg);
    if (isArt(g) && accentUsable(g.accent) && !seen[String(g.accent).toLowerCase()]) {
      o.push(swHtml(g.accent, t.accent === g.accent,
        (g.name || 'Design') + ' colour — the one this design was drawn around'));
    }
    return o.join('');
  }
  function bindAccents() {
    var row = $('lt-accrow');
    if (!row) return;
    row.querySelectorAll('[data-acc]').forEach(function (btn) {
      btn.onclick = function () {
        cur().accent = btn.getAttribute('data-acc');
        /* THE PICK IS RECORDED, not just applied: from here a new ground may
           repaint the label but never re-colours it. */
        cur()._accPicked = true;
        row.querySelectorAll('[data-acc]').forEach(function (b2) {
          b2.setAttribute('aria-pressed', b2 === btn ? 'true' : 'false');
        });
        sync();
      };
    });
  }
  /* repaint the swatch row ALONE: renderDetails() rebuilds the whole card and
     would take the focus out of whatever field is being typed in */
  function paintAccentRow() {
    var row = $('lt-accrow');
    if (!row) return;
    row.innerHTML = accentRowHtml(cur());
    bindAccents();
  }

  function renderDetails() {
    var host = $('lt-controls');
    if (!host) return;
    var t = cur();
    /* the disclosure's OWN state, seeded once from the content: without this a
       customer who typed an address and then closed the panel found it forced
       back open on the next repaint */
    if (st._addr === undefined) st._addr = !!(t.addr1 || t.addr2);
    var showAddr = !!st._addr;
    var customHdr = !!(t.hdr && t.hdr.trim() && HDR_PRESETS.indexOf(t.hdr) < 0) || st._customHdr;
    var rewardOn = !!t.reward || st._rewardOn;
    var customRw = !!(t.reward && REWARD_PRESETS.indexOf(t.reward) < 0) || st._customRw;
    var o = [];

    /* THE REQUIRED FIELD LEADS. Eight header-preset chips ahead of it cost
       three rows of a phone screen before the customer met the one box the
       order cannot go without. Order: name -> the routes a finder uses ->
       address (closed) -> wording -> reward -> handle -> accent. */
    o.push(field('f-name', 'Name',
      inputHtml('f-name', t.name, { cap: CAP.name, ph: 'Alex Rivera', ac: 'name' }),
      'The name a finder should ask for.', cntSpan('f-name')));

    o.push('<div class="row2">' +
      field('f-cc', 'Country code',
        (function () {
          var s = ['<select id="f-cc" aria-label="Country dialling code">'];
          DIALS.forEach(function (d) {
            s.push('<option value="' + d[0] + '"' + (st.cc === d[0] ? ' selected' : '') + '>' +
              d[0] + ' ' + d[1] + '</option>');
          });
          s.push('</select>');
          return s.join('');
        })()) +
      field('f-phone', 'Phone <span class="opt">optional</span>',
        inputHtml('f-phone', t.phone,
          { cap: CAP.phone, type: 'tel', im: 'tel', ph: '555 123 4567', ac: 'tel' }),
        '', cntSpan('f-phone')) +
      '</div>');

    o.push(field('f-email', 'Email <span class="opt">optional</span>',
      inputHtml('f-email', t.email,
        { cap: CAP.email, type: 'email', im: 'email', ph: 'you@example.com', ac: 'email' }),
      '', cntSpan('f-email')));
    o.push('<details class="adv" id="lt-addr"' + (showAddr ? ' open' : '') + '>' +
      '<summary>Add an address</summary>' +
      '<div class="hint" id="lt-addr-note">A full home address on a bag tells a stranger ' +
      'both where you live and that you are not there. A phone number gets the bag back just ' +
      'as fast. If you want a location on it, a city or a PO box is usually enough.</div>' +
      field('f-addr1', 'Address line 1',
        inputHtml('f-addr1', t.addr1,
          { cap: CAP.addr1, ph: '12 Bridge Street', ac: 'address-line1' }),
        '', cntSpan('f-addr1')) +
      field('f-addr2', 'Address line 2',
        inputHtml('f-addr2', t.addr2,
          { cap: CAP.addr2, ph: 'Portland, OR 97205', ac: 'address-line2' }),
        '', cntSpan('f-addr2')) +
      '</details>');

    /* header line — presets first, free text only when OWN… is chosen */
    o.push('<div class="optrow"><div class="optlb">Header line</div>' +
      '<div class="optseg lt-presets">');
    HDR_PRESETS.forEach(function (w) {
      var on = (t.hdr || LT.DEFAULT_HDR) === w && !customHdr && t.hdr !== ' ';
      o.push('<button type="button" class="optbtn' + (on ? ' on' : '') +
        '" data-hdr="' + esc(w) + '">' + esc(w) + '</button>');
    });
    o.push('<button type="button" class="optbtn' + (customHdr ? ' on' : '') +
      '" data-hdr="_c">OWN…</button>');
    o.push('<button type="button" class="optbtn' + (t.hdr === ' ' ? ' on' : '') +
      '" data-hdr="_none">NO HEADER</button></div>');
    if (customHdr) {
      o.push('<input class="optinp" type="text" id="f-hdr" maxlength="' + CAP.hdr +
        '" value="' + esc(HDR_PRESETS.indexOf(t.hdr) < 0 && t.hdr !== ' ' ? t.hdr : '') +
        '" placeholder="IF FOUND, PLEASE CONTACT" aria-label="Your header line">');
    }
    o.push('</div>');

    o.push('<div class="acks"><label class="ack' + (rewardOn ? ' on' : '') + '">' +
      '<input type="checkbox" id="lt-rewardon"' + (rewardOn ? ' checked' : '') + '>' +
      '<span><b>Add a reward line</b>' +
      '<span>One loud line a finder reads before anything else.</span></span></label></div>');
    if (rewardOn) {
      o.push('<div class="optrow"><div class="optseg lt-presets">');
      REWARD_PRESETS.forEach(function (w) {
        o.push('<button type="button" class="optbtn' + (t.reward === w ? ' on' : '') +
          '" data-rw="' + esc(w) + '">' + esc(w) + '</button>');
      });
      o.push('<button type="button" class="optbtn' + (customRw ? ' on' : '') +
        '" data-rw="_c">OWN…</button></div>');
      if (customRw) {
        o.push('<input class="optinp" type="text" id="f-reward" maxlength="' + CAP.reward +
          '" value="' + esc(REWARD_PRESETS.indexOf(t.reward) < 0 ? t.reward : '') +
          '" placeholder="REWARD IF FOUND" aria-label="Your reward wording">');
      }
      /* ALWAYS rendered, hidden until it applies. Pushing it conditionally
         meant it could only appear on the next full rebuild of this card —
         which sync() deliberately never does — so it turned up minutes later,
         unattached to the words that caused it. paintRewardNote() toggles it
         from the field's own handler, the way paintDensity() moves the byte
         meter. */
      o.push('<div class="lt-note" id="lt-reward-note" hidden>A printed amount invites a ' +
        'negotiation and it cannot be changed later. Most people leave the number off.</div>');
      o.push('</div>');
    }

    o.push(field('f-social', 'Social handle <span class="opt">optional</span>',
      inputHtml('f-social', t.social, { cap: CAP.social, ph: 'yourhandle' }),
      '', cntSpan('f-social')));
    o.push(field('f-note', 'Extra line <span class="opt">optional</span>',
      inputHtml('f-note', t.note, { cap: CAP.note, ph: 'CAMERA GEAR — PLEASE CALL' }),
      '', cntSpan('f-note')));

    o.push('<div class="field"><label>Accent colour</label>' +
      '<div class="swatches" id="lt-accrow">' + accentRowHtml(t) + '</div></div>');

    /* the two safety paragraphs, verbatim — the copy guard reads these */
    o.push('<p class="trustline"><b>Print only what you are comfortable with a stranger ' +
      'reading.</b> Anyone holding the item can read this label, and so can anyone standing ' +
      'next to it on a carousel. Most people print a first name, one phone number and an ' +
      'email. A street address is optional — we would leave it off anything that travels.</p>');
    /* UNGATED. This was behind `if (showAddr)`, so the one line on the page
       that tells a parent not to print a child's full name only reached the
       customers who had already opened the address disclosure — i.e. the ones
       least in need of the warning. The landing renders it unconditionally;
       the builder is where the text is actually typed, so it must too. */
    o.push('<p class="trustline">Putting one on a child’s bag or lunchbox? Print a ' +
      'parent’s phone number and a first name only — never a child’s full name, ' +
      'school or address.</p>');

    host.innerHTML = o.join('');

    host.querySelectorAll('[data-hdr]').forEach(function (btn) {
      btn.onclick = function () {
        var w = btn.getAttribute('data-hdr');
        if (w === '_c') { st._customHdr = true; cur().hdr = ''; }
        else if (w === '_none') { st._customHdr = false; cur().hdr = ' '; }
        else { st._customHdr = false; cur().hdr = w === LT.DEFAULT_HDR ? '' : w; }
        renderDetails();
        sync();
        _refocus('#lt-controls .lt-presets .optbtn.on', 24);
      };
    });
    host.querySelectorAll('[data-rw]').forEach(function (btn) {
      btn.onclick = function () {
        var w = btn.getAttribute('data-rw');
        if (w === '_c') { st._customRw = true; cur().reward = ''; }
        else { st._customRw = false; cur().reward = w; }
        renderDetails();
        sync();
        _refocus('#lt-controls [data-rw].on', 24);
      };
    });
    bindAccents();
    if ($('f-hdr')) bindField('f-hdr', 'hdr', CAP.hdr);
    bindField('f-name', 'name', CAP.name);
    bindField('f-email', 'email', CAP.email);
    bindField('f-note', 'note', CAP.note);
    bindField('f-social', 'social', CAP.social, function (t2, el) {
      var v = el.value.replace(/^@+/, '')
        .replace(/^(?:https?:\/\/)?(?:www\.)?instagram\.com\//i, '');
      if (v !== el.value) el.value = v;
      t2.social = v.slice(0, CAP.social);
    });
    bindField('f-addr1', 'addr1', CAP.addr1);
    bindField('f-addr2', 'addr2', CAP.addr2);
    if ($('f-reward')) bindField('f-reward', 'reward', CAP.reward, paintRewardNote);
    paintRewardNote();
    bindField('f-phone', 'phone', CAP.phone, function (t2) {
      t2.e164 = toE164(t2.phone, st.cc);
    });
    var cc = $('f-cc');
    if (cc) cc.onchange = function () {
      st.cc = cc.value;
      cur().e164 = toE164(cur().phone, st.cc);
      sync();
    };
    var ad = $('lt-addr');
    if (ad) ad.ontoggle = function () {
      if (st._addr === ad.open) return;
      st._addr = ad.open;
      renderDetails();
      sync();
      _refocus('#lt-addr > summary', 24);
    };
    var rw = $('lt-rewardon');
    if (rw) rw.onchange = function () {
      st._rewardOn = this.checked;
      if (this.checked && !cur().reward) cur().reward = LT.DEFAULT_REWARD;
      if (!this.checked) { cur().reward = ''; st._customRw = false; }
      renderDetails();
      sync();
      _refocus('#lt-rewardon', 24);
    };
  }

  /* ═══════════════ LOGO ══════════════════════════════════════════════════
     The seal builder's uploader, ported: the same 12 MB ceiling, the same
     700x700 downscale, the same alpha-blind backdrop key-out, the same Worker
     relay and the same iOS-safe picker. The only edits are the ones the
     comments below name. */

  var UP_MAX_MB = { logo: 12 };
  var UP_MAX_MP = 40;
  var RIGHTS_SUB = 'Our included commercial licence covers Serial Seal designs only — ' +
    'uploaded logos print under your own rights.';

  function upTooBig(file, kind) {
    var lim = UP_MAX_MB[kind] || 12;
    if (!file || !file.size) return '';
    if (file.size > lim * 1024 * 1024) {
      return 'That file is ' + (file.size / 1048576).toFixed(1) + ' MB — the limit is ' +
        lim + ' MB. Export it smaller (or take a screenshot of it) and try again. ' +
        'A label is ' + size().shortIn + '″ tall, so a big file cannot print any sharper.';
    }
    return '';
  }
  function downscale(img, maxW, maxH, mime, q) {
    var s = Math.min(maxW / img.width, maxH / img.height, 1);
    var w = Math.round(img.width * s), h = Math.round(img.height * s);
    var cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    cv.getContext('2d').drawImage(img, 0, 0, w, h);
    return { dataUrl: cv.toDataURL(mime, q), w: w, h: h, cv: cv };
  }
  function ssLum(r, g, b) { return 0.2126 * r + 0.7152 * g + 0.0722 * b; }
  /* Logo intake — CLEANS rather than rejects. The press is alpha-blind:
     whatever is opaque prints, so a mark sitting on a white or checkerboard
     backdrop lays a box over the foil. Refusing those files turned away
     perfectly usable logos, so we key the backdrop out ourselves and only
     refuse when nothing can be salvaged. Mutates the canvas in place. */
  function cleanLogo(cv) {
    var ctx = cv.getContext('2d', { willReadFrequently: true }), img;
    try { img = ctx.getImageData(0, 0, cv.width, cv.height); }
    catch (_) { return { unreadable: true }; }
    var d = img.data, n = cv.width * cv.height, i, r, g, b, a;

    var clear = 0, partial = 0, visible = 0, darkVis = 0, buckets = {}, bk;
    for (i = 0; i < n; i++) {
      a = d[i * 4 + 3];
      if (a < 16) { clear++; continue; }
      if (a < 250) partial++;
      visible++;
      r = d[i * 4]; g = d[i * 4 + 1]; b = d[i * 4 + 2];
      var lum = ssLum(r, g, b);
      if (lum < 170) darkVis++;
      if (lum > 200) {
        bk = ((r >> 4) << 8) | ((g >> 4) << 4) | (b >> 4);
        buckets[bk] = (buckets[bk] || 0) + 1;
      }
    }
    if (visible < n * 0.004) return { blank: true };
    if (clear > 0 || partial > 0) {
      return { clearPct: clear / n, cleaned: false, plate: darkVis < visible * 0.45 };
    }

    var topBk = null, topCount = 0, top2Bk = null, top2Count = 0, k;
    for (k in buckets) if (buckets[k] > topCount) { topCount = buckets[k]; topBk = +k; }
    for (k in buckets) if (+k !== topBk && buckets[k] > top2Count) { top2Count = buckets[k]; top2Bk = +k; }
    function bkRgb(v) { return [((v >> 8) & 15) * 16 + 8, ((v >> 4) & 15) * 16 + 8, (v & 15) * 16 + 8]; }
    function neutral(c) { return Math.max(c[0], c[1], c[2]) - Math.min(c[0], c[1], c[2]) < 24; }

    var keyCols = [];
    if (topBk !== null && topCount > visible * 0.40) {
      keyCols = [bkRgb(topBk)];
      if (top2Bk !== null && top2Count > visible * 0.12 &&
          neutral(bkRgb(topBk)) && neutral(bkRgb(top2Bk))) keyCols.push(bkRgb(top2Bk));
    } else if (topBk !== null && top2Bk !== null &&
               (topCount + top2Count) > visible * 0.40 &&
               topCount > visible * 0.12 && top2Count > visible * 0.12 &&
               neutral(bkRgb(topBk)) && neutral(bkRgb(top2Bk))) {
      keyCols = [bkRgb(topBk), bkRgb(top2Bk)];
    }
    if (!keyCols.length) return { solidBox: true, opaque: true };

    var keyed = 0;
    for (i = 0; i < n; i++) {
      a = d[i * 4 + 3];
      if (a <= 8) continue;
      r = d[i * 4]; g = d[i * 4 + 1]; b = d[i * 4 + 2];
      var dist = 999, kk, dd;
      for (kk = 0; kk < keyCols.length; kk++) {
        dd = Math.max(Math.abs(r - keyCols[kk][0]), Math.abs(g - keyCols[kk][1]),
                      Math.abs(b - keyCols[kk][2]));
        if (dd < dist) dist = dd;
      }
      if (dist < 26) { d[i * 4 + 3] = 0; keyed++; }
      else if (dist < 48) { d[i * 4 + 3] = Math.round(a * (dist - 26) / 22); keyed++; }
    }
    if (!keyed) return { solidBox: true, opaque: true };

    var left = 0, dark = 0;
    for (i = 0; i < n; i++) {
      if (d[i * 4 + 3] <= 60) continue;
      left++;
      if (ssLum(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]) < 170) dark++;
    }
    if (left < n * 0.004) return { blank: true };

    ctx.putImageData(img, 0, 0);
    return { clearPct: keyed / n, cleaned: true, plate: dark < left * 0.45 };
  }

  function updateLogoTile() {
    var t = $('lt-logo-tile');
    if (!t) return;
    if (st.logo) {
      t.classList.add('has');
      t.innerHTML = '<img src="' + esc(st.logo.thumb || st.logo.dataUrl || st.logo.url) +
        '" alt="Your logo">';
    } else {
      t.classList.remove('has');
      t.innerHTML =
        '<span class="lt-ic" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
          '<path d="M12 16V5M7.5 9 12 4.5 16.5 9" fill="none" stroke="currentColor" ' +
          'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M5 19h14" fill="none" stroke="currentColor" stroke-width="2.2" ' +
          'stroke-linecap="round"/></svg></span>' +
        '<span class="lt-tx"><b>Upload your logo</b>' +
        '<span>PNG or JPG · we place it front &amp; centre</span></span>';
    }
  }
  function showErr(kind, msg) {
    var e = $(kind + '-err');
    if (!e) return;
    e.hidden = !msg; e.textContent = msg || '';
    var d = $(kind + '-drop');
    if (d) d.classList.toggle('bad', !!msg);
  }
  /* the label's own fields are what the renderer, the cart and the press read:
     `lo` is the CDN url (what ships), `_data` is the session dataURL (what
     previews). st.logo is the uploader's card state; these two are kept in
     step by this one function. */
  function syncLogoToLabel() {
    var t = cur();
    t.lo = (st.logo && st.logo.url) || '';
    t._data = (st.logo && st.logo.dataUrl) || '';
    if (!st.logo) st.rightsOk = false;
  }
  function mountUploader() {
    var slot = $('logo-slot');
    if (!slot) return;
    var f = st.logo;
    if (!f) { slot.innerHTML = ''; updateLogoTile(); renderRights(); return; }
    slot.innerHTML =
      '<div class="upfile"><img class="th" alt="Uploaded logo preview" src="' +
        esc(f.thumb || f.dataUrl || f.url) + '">' +
      '<span class="meta"><b>' + esc(f.name || 'logo') + '</b>' +
      '<span>' + (f.w ? f.w + '×' + f.h + ' px · ' : '') + (f.kb ? f.kb + ' KB' : '') +
      (f.note ? (f.w || f.kb ? ' · ' : '') + esc(f.note) : '') + '</span></span>' +
      '<span class="acts"><button type="button" data-a="replace">Replace</button>' +
      '<button type="button" data-a="remove">Remove</button></span></div>';
    slot.querySelector('[data-a="replace"]').onclick = function () { pickFile('logo'); };
    slot.querySelector('[data-a="remove"]').onclick = function () {
      st.logo = null;
      syncLogoToLabel();
      mountUploader();
      renderRights();
      sync();
    };
    /* NO "Logo size" SLIDER. It was inert: st.logoScale reached neither
       cfgOf() nor toCompact(), so it changed neither the preview, nor the `_lt`
       cart payload, nor the press — and assets/lt-label.js has no scale
       parameter at all (logoBox() takes a fixed mm box per layout). A control
       that promises to resize the printed logo and does nothing is worse than
       no control. Reinstating it needs a renderer change first: emit `lgs` in
       toCompact(), read it in LT.norm(), scale logoBox(), then add `lgs` to
       lt_spec §3 and to ss-cart.js ltCfg(). */
    /* the rights TERM, stated — and, because an uploaded mark is the customer's
       to clear, ticked before the order goes through */
    var ra = document.createElement('p');
    ra.className = 'hint';
    ra.style.marginTop = '8px';
    ra.textContent = RIGHTS_SUB;
    slot.appendChild(ra);
    updateLogoTile();
    renderRights();
  }
  function renderRights() {
    var host = $('lt-logo-detail');
    if (!host) return;
    var row = $('lt-rights-row');
    if (!st.logo) { if (row) row.parentNode.removeChild(row); return; }
    if (!row) {
      row = document.createElement('div');
      row.id = 'lt-rights-row';
      row.className = 'acks';
      row.innerHTML = '<label class="ack"><input type="checkbox" id="lt-rights">' +
        '<span><b>I own the uploaded artwork or have the rights holder’s approval ' +
        'to print it.</b><span>' + esc(RIGHTS_SUB) + '</span></span></label>';
      host.appendChild(row);
      $('lt-rights').onchange = function () {
        st.rightsOk = this.checked;
        row.querySelector('.ack').classList.toggle('on', this.checked);
        sync();
      };
    }
    var cb = $('lt-rights');
    if (cb) {
      cb.checked = !!st.rightsOk;
      row.querySelector('.ack').classList.toggle('on', !!st.rightsOk);
    }
  }
  /* Module-scoped ref: a detached input with no live reference can be GC'd by
     Safari while the native picker is still open — onchange never fires and
     the tap "does nothing". Holding it here pins it for the picker's lifetime. */
  var _fileInp = null;
  function pickFile() {
    var inp = document.createElement('input');
    inp.type = 'file';
    /* ANY image, logos included: accept='image/png' was a hard gate at the OS
       picker — a customer whose logo is a JPG could not select their file at
       all, which reads as a broken button. cleanLogo() keys out a flat
       backdrop where it can and the live proof shows exactly what prints. */
    inp.accept = 'image/*';
    inp.onchange = function () {
      if (this.files[0]) handleFile(this.files[0]);
      if (inp.parentNode) inp.parentNode.removeChild(inp);
      _fileInp = null;
    };
    /* iOS Safari: an input that is not IN the document can silently refuse to
       open the picker, and one GC'd mid-pick never fires onchange. Attached
       off-screen + module-pinned covers both. Off-screen is still FOCUSABLE,
       so it is taken out of the tab order, hidden from AT and swept on cancel. */
    inp.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0';
    inp.tabIndex = -1;
    inp.setAttribute('aria-hidden', 'true');
    try {
      var _old = document.querySelectorAll('input[type=file][data-lt-picker]');
      for (var _i = 0; _i < _old.length; _i++) _old[_i].parentNode.removeChild(_old[_i]);
    } catch (_) {}
    inp.setAttribute('data-lt-picker', '1');
    window.addEventListener('focus', function () {
      if (inp.parentNode && !(inp.files && inp.files.length)) {
        try { inp.parentNode.removeChild(inp); } catch (_) {}
      }
    }, { once: true });
    document.body.appendChild(inp);
    _fileInp = inp;
    inp.click();
  }
  function uploadFile() {
    var f = st.logo;
    if (!f || f.url || f.uploadP) return;
    /* A HANG IS NOT A FAILURE, so it never took the failure path: placeOrder
       waits on this promise, and a socket that stalled without erroring left
       the buy button on "Saving your logo…" forever. The abort turns a hang
       into the same uploadErr fallback a failed upload takes. */
    var _ac = null, _tm = null;
    try {
      _ac = new AbortController();
      _tm = setTimeout(function () { _ac.abort(); }, 25000);
    } catch (_) {}
    f.uploadP = fetch(CFG.worker + '/upload', {
      method: 'POST',
      signal: _ac ? _ac.signal : undefined,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: f.name, data: f.dataUrl, kind: 'logo' })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (_tm) clearTimeout(_tm);
      if (d && d.ok && (d.url || d.id)) {
        f.url = d.url || '';
        f.fileId = d.id || '';
        f.note = (f.note ? f.note + ' · ' : '') + 'saved';
        syncLogoToLabel();
        mountUploader();
        sync();
      } else { f.uploadErr = true; mountUploader(); sync(); }
    }).catch(function () {
      if (_tm) clearTimeout(_tm);
      f.uploadErr = true;
      mountUploader();
      sync();                        /* blockers() refuses the add on this */
    });
  }
  function handleFile(file) {
    showErr('logo', '');
    /* refuse BEFORE the FileReader — a 12MB HEIC can decode to 60 megapixels
       and the canvas backing store is w*h*4 bytes */
    var tooBig = upTooBig(file, 'logo');
    if (tooBig) { showErr('logo', tooBig); toast('File too large', true); return; }
    var rd = new FileReader();
    rd.onload = function () {
      var im = new Image();
      im.onload = function () {
        if (im.width * im.height > UP_MAX_MP * 1000000) {
          showErr('logo', 'That image is ' + im.width + '×' + im.height +
            ' — too large to process in a browser. Resize it to about 3000×3000 and try again.');
          return;
        }
        /* Analyse and clean the canvas we actually KEEP, so the backdrop we key
           out is gone from the stored artwork too — not just from the check. */
        var out = downscale(im, 700, 700, 'image/png');
        var rep = cleanLogo(out.cv);
        if (rep.unreadable) {
          showErr('logo', 'That file could not be read. Try exporting it again, or upload ' +
            'a different image.');
          return;
        }
        /* Blank and solid-box are WARNINGS, not dead ends: the preview beside
           this control shows exactly what would print, so the customer can see
           the box for themselves. Only an undecodable file still blocks. */
        var warn = '';
        if (rep.blank) warn = 'This looks blank — check the preview shows your logo.';
        else if (rep.opaque) {
          warn = 'This file has a solid background, so that background prints as a block ' +
            'over the foil — see the preview. Artwork with a transparent background sits ' +
            'directly on the material, but either one prints.';
        }
        var thumbCv = document.createElement('canvas');
        var ts = Math.min(220 / out.cv.width, 220 / out.cv.height, 1);
        thumbCv.width = Math.max(1, Math.round(out.cv.width * ts));
        thumbCv.height = Math.max(1, Math.round(out.cv.height * ts));
        thumbCv.getContext('2d').drawImage(out.cv, 0, 0, thumbCv.width, thumbCv.height);
        var cleanUrl = out.cv.toDataURL('image/png');
        st.logo = { name: file.name, dataUrl: cleanUrl, w: im.width, h: im.height,
                    kb: Math.round(cleanUrl.length / 1365),
                    thumb: thumbCv.toDataURL('image/png'),
                    plate: !!rep.plate,
                    note: (rep.opaque ? 'prints as uploaded' : 'transparent') +
                          (rep.plate ? ' · dark backing added' : '') };
        st.rightsOk = false;
        syncLogoToLabel();
        mountUploader();
        uploadFile();
        if (warn) { showErr('logo', warn); toast('Logo added — check the preview', true); }
        else toast(rep.cleaned ? 'Logo added — background removed' : 'Logo added');
        sync();
      };
      im.onerror = function () { showErr('logo', 'That image could not be decoded.'); };
      im.src = rd.result;
    };
    rd.readAsDataURL(file);
  }

  /* ═══════════════ THE QR CARD ═══════════════════════════════════════════ */

  function actionOf(k) {
    for (var i = 0; i < ACTIONS.length; i++) if (ACTIONS[i].k === k) return ACTIONS[i];
    return ACTIONS[0];
  }
  function renderQrChip() {
    var c = $('lt-qr-chip');
    if (!c) return;
    c.textContent = actionOf(cur().qa).n;
  }
  function densClass(q) { return q.over ? 'bad' : (q.near ? 'warn' : 'ok'); }
  function densText(q) {
    if (!q.payload) return 'Add the detail above and the code appears here.';
    if (q.over) {
      return '⚠ ' + q.bytes + ' bytes — over the ' + q.cap + ' this size holds. ' +
        'Too dense to scan reliably.';
    }
    return 'QR · ' + q.bytes + ' of ' + q.cap + ' bytes' +
      (q.near ? ' — close to the limit' : ' ✓');
  }
  /* the printed plain-text route under the code is a hard requirement (a
     finder with a dead phone is the most likely finder), so the builder shows
     exactly what will print — including the styles that print no caption. */
  function fallHtml(q, lay) {
    if (!q.payload) return 'Nothing to scan yet.';
    var capLine = (lay && lay.qrCaption === false) || !q.caption
      ? '' : '<br>Caption above it: <b>' + esc(q.caption) + '</b>';
    return 'Printed under the code: <b>' + esc(q.fallback) + '</b>' + capLine;
  }
  /* the meter has to move with every keystroke, and a full rebuild would take
     the focus out of the field the customer is typing in */
  function paintDensity() {
    var el = $('lt-bytes');
    if (!el) return;
    var q = qrState(cur());
    el.className = 'opthint ' + densClass(q);
    el.innerHTML = esc(densText(q));
    if (q.over && st.sizeId !== SID_LG && sizeLive(SID_LG)) offerLarge(el);
    var f = $('lt-fall');
    if (f) f.innerHTML = fallHtml(q, layoutOf(cur()));
    renderQrChip();
  }
  /* the one place the standard die's byte cap is turned into an offer rather
     than a dead end */
  function offerLarge(host, id) {
    if (!host) return;
    id = id || 'lt-golarge';
    host.innerHTML += ' <button type="button" class="lnk" id="' + id +
      '">' + (isCombo() ? 'Switch to Large only' : 'Switch to Large') + '</button>';
    var btn = $(id);
    if (btn) btn.onclick = function () { applySize(SID_LG); };
  }

  function renderQr() {
    var host = $('lt-qrbody');
    if (!host) return;
    var t = cur();
    var lay = layoutOf(t);
    var o = ['<div class="optrow">',
             '<div class="optlb">What happens when they scan?</div>',
             '<div class="optseg">'];
    ACTIONS.forEach(function (a) {
      o.push('<button type="button" class="optbtn' + (t.qa === a.k ? ' on' : '') +
        '" data-qa="' + a.k + '" aria-pressed="' + (t.qa === a.k ? 'true' : 'false') +
        '">' + esc(a.n) + '</button>');
    });
    o.push('</div>');
    o.push('<p class="qrsub">' + esc(actionOf(t.qa).s) + '</p>');

    if (t.qa === 'none') {
      o.push('<p class="opthint">The label prints your details in type only. Nothing to scan.</p>');
    } else {
      if (t.qa === 'call' || t.qa === 'whatsapp') {
        o.push('<p class="opthint">Uses the phone number above.</p>');
      }
      if (t.qa === 'text' || t.qa === 'email') {
        o.push('<label class="optlb" for="f-qb" style="margin-top:10px">' +
          (t.qa === 'text' ? 'Message they’ll see' : 'Subject line') +
          cntSpan('f-qb') + '</label>' +
          inputHtml('f-qb', t.qb, { cap: CAP.qb, cls: 'optinp',
            ph: t.qa === 'text' ? 'Found your bag' : 'Found your item' }));
      }
      if (t.qa === 'instagram') {
        o.push('<label class="optlb" for="f-qsocial" style="margin-top:10px">' +
          'Instagram handle' + cntSpan('f-qsocial') + '</label>' +
          inputHtml('f-qsocial', t.social, { cap: CAP.social, cls: 'optinp',
            ph: 'yourhandle' }));
      }
      if (t.qa === 'web') {
        o.push('<label class="optlb" for="f-qd" style="margin-top:10px">' +
          'Web address' + cntSpan('f-qd') + '</label>' +
          inputHtml('f-qd', t.qd, { cap: CAP.qd, cls: 'optinp', type: 'url', im: 'url',
            ph: 'yoursite.com/found' }));
      }
      o.push('<p class="opthint" id="lt-bytes"></p>');
      o.push('<p class="opthint" id="lt-fall"></p>');
      o.push('<p class="opthint">Scanning opens your number, your inbox or your profile ' +
        'directly on the finder’s phone. Nothing is routed through us and we never ' +
        'see the scan.</p>');
      if (!lay.qr) {
        o.push('<div class="lt-note">The ' + esc(lay.name) + ' style prints no code — pick ' +
          'another style above, or the code is left off.</div>');
      } else if (lay.qrActions && lay.qrActions.indexOf(t.qa) < 0) {
        o.push('<div class="lt-note">The ' + esc(lay.name) + ' style carries a Call, Text or ' +
          'WhatsApp code only — pick another style above, or another action here.</div>');
      }
    }
    o.push('<div class="err" id="f-qr-err" role="alert" hidden></div>');
    o.push('</div>');
    host.innerHTML = o.join('');

    host.querySelectorAll('[data-qa]').forEach(function (btn) {
      btn.onclick = function () {
        var was = cur().qa;
        var k = btn.getAttribute('data-qa');
        /* a repeat tap must still REPAINT (a customer who taps the lit chip is
           asking "what does this say?"), but it must not wipe the destination
           they already typed for that same action */
        if (k === was) { paintDensity(); return; }
        cur().qa = k;
        /* qd and qb belong to the action that was chosen, not to the label: an
           sms body silently re-used as a mail subject is both a surprise and a
           quiet way to blow the byte budget of the next code */
        cur().qd = ''; cur().qb = '';
        renderQr();
        paintLayNote();
        sync();
        _refocus('#lt-qrbody .optbtn.on', 24);
      };
    });
    if ($('f-qb')) bindField('f-qb', 'qb', CAP.qb, function () { paintDensity(); });
    if ($('f-qd')) bindField('f-qd', 'qd', CAP.qd, function () { paintDensity(); });
    if ($('f-qsocial')) {
      var el = $('f-qsocial');
      el.oninput = function () {
        var v = el.value.replace(/^@+/, '')
          .replace(/^(?:https?:\/\/)?(?:www\.)?instagram\.com\//i, '');
        if (v !== el.value) el.value = v;
        cur().social = v.slice(0, CAP.social);
        paintCnt('f-qsocial', CAP.social);
        paintDensity();
        sync();
      };
      paintCnt('f-qsocial', CAP.social);
    }
    paintDensity();
  }

  /* ═══════════════ MATERIAL ══════════════════════════════════════════════ */

  var MAT_COPY = {
    'Shattered Prism': 'Fractured-glass sparkle',
    'Aurora': 'A smoother wash of drifting colour',
    'Gloss White': 'Plain white gloss, no rainbow shine'
  };
  /* Gloss White (2026-10-18): plain white vinyl - previewed on a white
     ground with the foil sim off (LT.mount {white:true}) */
  function isWhiteStock(name) { return /white|gloss/i.test(String(name == null ? st.material : name) || ''); }
  function matPhoto(name) {
    if (isWhiteStock(name)) return CFG.matWhite || '';
    return /prism/i.test(name) ? (CFG.matPrism || '') : (CFG.matAurora || '');
  }
  /* only ever a fallback: if a swatch URL is missing, a CSS approximation is
     better than an empty box */
  function matDot(name) {
    if (isWhiteStock(name)) return '#f4f4f6';
    return /prism/i.test(name)
      ? 'repeating-linear-gradient(48deg,#e8eef8 0 3px,#93a6c4 3px 6px)'
      : 'linear-gradient(120deg,#bfe9ff,#e6c9ff,#ffe2b8,#c6ffe0)';
  }
  function renderMaterial() {
    var host = $('lt-matpick');
    if (!host) return;
    /* LARGE HIDES PRISM FOR FREE: the card list is built from the Large
       product's own variants, which are Aurora only. */
    var all = VARIANTS[st.sizeId] || [];
    if (!variantFor(st.sizeId, st.material)) {
      var v0 = variantsFor(st.sizeId)[0];
      if (v0) st.material = v0.material;
    }
    host.innerHTML = '';
    all.forEach(function (v) {
      var on = String(v.material).toLowerCase() === String(st.material).toLowerCase();
      var out = !v.available;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'matcard' + (on ? ' on' : '') + (out ? ' out' : '');
      b.disabled = out;
      b.setAttribute('data-mat', v.material);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', v.material + ' — ' + (MAT_COPY[v.material] || '') +
        (out ? ' (sold out)' : ''));
      var src = matPhoto(v.material);
      b.innerHTML = '<span class="matsw" aria-hidden="true"' +
          (src ? '' : ' style="background:' + matDot(v.material) + '"') + '>' +
          (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" decoding="async">' : '') +
        '</span>' +
        '<span class="mattx"><b>' + esc(v.material) + (function(n){ var t=/prism|shatter/i.test(n)?['exotic','Exotic']:(/aurora/i.test(n)?['ultra','Ultra']:['base','Base']); return ' <span class="va-tier va-tier-'+t[0]+'" title="'+t[1]+' tier"><svg viewBox="0 0 12 12" width="9" height="9" aria-hidden="true"><path d="M6 .6 11.4 6 6 11.4 .6 6z" fill="currentColor"/></svg>'+t[1]+'</span>'; })(v.material) + (out ? ' <i>sold out</i>' : '') + '</b>' +
        '<span>' + esc(MAT_COPY[v.material] || '') + '</span></span>';
      b.onclick = function () {
        if (out) return;
        st.material = v.material;
        st._editBad = false;        /* ...and the material */
        renderMaterial();
        renderSizeCards();          /* the card prices are this material's */
        renderQtiers();
        renderPreview();
        _refocus('#lt-matpick .matcard.on');
        sync();
      };
      host.appendChild(b);
    });
    var note = $('lt-matnote');
    if (note) {
      note.innerHTML = '<span>' + (isWhiteStock()
          ? '<b>Gloss White is plain white vinyl</b> with a permanent adhesive — no holographic ' +
            'shine; unprinted areas print white. It does not come off in one piece.'
          : '<b>The holographic stocks are silver vinyl</b> ' +
            'with a permanent adhesive — it does not come off in one piece. Screen colour is not ' +
            'print colour: holo foil shifts colour with the light.') +
        (st.sizeId === SID_LG ? ' The Large die prints on Aurora.' : '') + '</span>';
      /* the combo's one line of truth about the second foil: the Large product
         sells what it sells, whichever card is lit here */
      /* its own element under the note: .matnote is a flex row, and a second
         span inside it became a narrow side column */
      var lv = isCombo() ? lgComboVariant() : null;
      var mc = $('lt-matcombo');
      if (!mc && note.parentNode) {
        mc = document.createElement('p');
        mc.id = 'lt-matcombo';
        mc.className = 'lt-note';
        note.parentNode.insertBefore(mc, note.nextSibling);
      }
      if (mc) {
        mc.hidden = !lv;
        mc.innerHTML = lv ? '<b>Large labels print on ' + esc(lv.material) + '.</b>' +
          (String(lv.material).toLowerCase() !== String(st.material).toLowerCase()
            ? ' Your Standard labels print on ' + esc(st.material) + '.' : '') : '';
      }
    }
  }

  /* ═══════════════ QUANTITY ══════════════════════════════════════════════ */

  /* the ladder is EMPTY until the automatic discounts exist — an advertised
     rung Shopify will not apply is the one defect this family has fixed most
     often. Descending, so bulkRate() finds the deepest earned rung first. */
  var TIERS = (CFG.tiers || []).slice().sort(function (a, b) { return b[0] - a[0]; });
  function bulkAsc() { return TIERS.slice().reverse(); }
  function bulkRate(k) {
    for (var i = 0; i < TIERS.length; i++) if (k >= TIERS[i][0]) return TIERS[i][1];
    return 0;
  }
  /* the next rung in STEPPER UNITS: a pack, or in combo a set — a set puts
     two packs in the pool, so the 10-pack rung is 5 sets */
  function unitsFor(packsNeeded) { return Math.ceil(packsNeeded / packsPerUnit()); }
  function nextTier(k) {
    var asc = bulkAsc();
    for (var i = 0; i < asc.length; i++) {
      var u = unitsFor(asc[i][0]);
      if (k < u) return [u, asc[i][1]];
    }
    return null;
  }
  /* Everything is computed in integer CENTS and divided once at the end, so
     the struck-through gross, the saving and the price are the same three
     integers checkout will use and gross - save === price on every surface.
     PER-UNIT FLOOR: checkout floors the discount on ONE unit and multiplies by
     the quantity — it does not floor the cart total. +1e-6 BEFORE the floor
     repairs the binary representation of a rate that is exact in decimal.
     THE POOL IS EVERY LINE THIS ADD WRITES: the four automatic discounts are
     scoped to BOTH lost products, so a combo's two lines count together
     (5 sets = 10 packs = the 10% rung), and each line is floored on its own
     unit price, the way checkout does it. */
  function quoteFor(k) {
    var ls = orderLines(k);
    var pool = 0, cents = 0, n = 0, discount = 0;
    ls.forEach(function (L) { pool += L.qty; });
    var rate = bulkRate(pool);
    ls.forEach(function (L) {
      cents += L.v.cents * L.qty;
      n += L.v.perPack * L.qty;
      discount += Math.floor(L.v.cents * rate + 1e-6) * L.qty;
    });
    return { packs: k, n: n, gross: cents / 100, rate: rate, pool: pool,
             save: discount / 100, price: (cents - discount) / 100 };
  }

  function renderQtiers() {
    var host = $('lt-qtier');
    if (!host) return;
    var ls = orderLines(1);
    if (!ls.length || !TIERS.length) { host.innerHTML = ''; return; }
    var tiles;
    if (isCombo()) {
      /* a set is two different prices, so a combo tile quotes the SET — the
         Standard pack plus the Large pack, each floored the way checkout
         floors it — rather than an averaged "each" */
      var setAt = function (rate) {
        return ls.reduce(function (c, L) {
          return c + L.v.cents - Math.floor(L.v.cents * rate + 1e-6);
        }, 0);
      };
      var per1 = labelsPerUnit();
      tiles = [[MIN_UNITS, sealNum(per1 * MIN_UNITS) + ' labels', money(setAt(0) * MIN_UNITS),
                'minimum']];
      bulkAsc().forEach(function (t) {
        var u = Math.max(MIN_UNITS, unitsFor(t[0]));
        tiles.push([u, sealNum(u * per1) + '+ labels', money(setAt(t[1])) + ' / set',
                    Math.round(t[1] * 100) + '% off']);
      });
    } else {
      var v = ls[0].v;
      var per = v.cents / v.perPack / 100;
      tiles = [[MIN_UNITS, sealNum(v.perPack * MIN_UNITS) + ' labels', money(v.cents * MIN_UNITS),
                'minimum']];
      bulkAsc().forEach(function (t) {
        tiles.push([t[0], sealNum(t[0] * v.perPack) + '+ labels',
                    fmtPerSeal(per * (1 - t[1])) + ' each',
                    Math.round(t[1] * 100) + '% off']);
      });
    }
    host.innerHTML = '<div class="qd-grid">' + tiles.map(function (t) {
      return '<button type="button" class="qd-tier" data-lttier="' + t[0] + '"' +
        ' aria-pressed="false" aria-label="Set the quantity to ' + t[0] + ' ' +
        unitWord(t[0]) + '">' + esc(t[1]) + '<b>' + esc(t[2]) + '</b>' +
        '<i class="qd-sub">' + esc(t[3]) + '</i></button>';
    }).join('') + '</div>';
    renderQuantity();
  }
  function applyTier(packs) {
    packs = parseInt(packs, 10);
    if (!packs || packs < 1) return;
    var was = st.packs;
    setPacks(packs);
    var q = quoteFor(st.packs);
    if (st.packs !== was) {
      toast(sealNum(q.n) + ' labels' + (q.rate ? ' — ' + pctOf(q.rate) + '% off' : ''));
    } else {
      toast(q.rate
        ? 'You already have ' + pctOf(q.rate) + '% off at ' + sealNum(q.n) + ' labels'
        : 'You have ' + sealNum(q.n) + ' labels — use + to add more');
    }
    revealQty();
  }
  /* Show them what changed: the tapped chip can be the only thing on screen,
     so bring the quantity box into view when it is not already and pulse it
     either way — a tap that deliberately changed nothing still has to point at
     the state that made it a no-op, or it reads as a dead tap. */
  function revealQty() {
    var box = $('lt-packs');
    if (!box) return;
    var r = box.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (r.top < 8 || r.bottom > vh - 8) smoothTo(box, 'center');
    box.classList.remove('ss-qflash');
    void box.offsetWidth;
    box.classList.add('ss-qflash');
  }
  function setPacks(n) {
    n = parseInt(n, 10);
    if (!isFinite(n) || n < 1) n = MIN_UNITS;
    /* NEVER SILENTLY OVERWRITE A TYPED QUANTITY — the clamp stays, but the
       customer is told what happened */
    if (n < MIN_UNITS) {
      toast('The minimum is ' + MIN_UNITS + ' ' + unitWord(MIN_UNITS) + ' (' +
        sealNum(MIN_UNITS * labelsPerUnit()) + ' labels)', true);
      n = MIN_UNITS;
    }
    var mx = maxUnits();
    if (n > mx) {
      toast('Self-serve tops out at ' + mx + ' ' + unitWord(mx) + ' (' +
        sealNum(mx * labelsPerUnit()) + ' labels) — bigger runs get volume pricing', true);
    }
    st.packs = Math.max(MIN_UNITS, Math.min(mx, n));
    st._pinPack = false;
    renderQuantity();
    sync();
  }

  /* log scale from ONE unit: linear would bury 1-50, where every real order
     lives, in the first tenth of the track. The top is the MODE's cap (a combo
     set is two packs, so it tops out at half the packs). */
  /* ...and its ORIGIN is the minimum: the far left of the track is the
     smallest order the page sells, never a quantity it would refuse */
  var _LNMN = Math.log(MIN_UNITS);
  function _lnmx() { return Math.log(Math.max(MIN_UNITS + 1, maxUnits())); }
  function qslToPacks(v) {
    var t = Math.max(0, Math.min(1000, +v || 0)) / 1000;
    return Math.max(MIN_UNITS, Math.min(maxUnits(),
      Math.round(Math.exp(_LNMN + t * (_lnmx() - _LNMN)))));
  }
  function packsToQsl(k) {
    return Math.round(1000 * (Math.log(Math.max(MIN_UNITS, k || MIN_UNITS)) - _LNMN) /
                      (_lnmx() - _LNMN));
  }

  function renderQuantity() {
    var inp = $('lt-qin');
    if (!inp) return;
    var combo = isCombo(), ls = orderLines(1);
    var unit1 = combo ? 'set' : 'pack';
    inp.max = maxUnits();
    inp.min = MIN_UNITS;
    inp.setAttribute('aria-label', 'Number of ' + unit1 + 's');
    document.querySelectorAll('#lt-packs .va-qsb').forEach(function (b) {
      var down = b.getAttribute('data-qd') !== '1';
      b.setAttribute('aria-label', 'One ' + unit1 + (down ? ' fewer' : ' more'));
      /* the "-" stops AT the minimum — a dead-looking button beats one that
         toasts a refusal on every press */
      if (down) {
        var atMin = st.packs <= MIN_UNITS;
        b.disabled = atMin;
        b.setAttribute('aria-disabled', atMin ? 'true' : 'false');
        b.title = atMin ? 'Minimum ' + MIN_UNITS + ' ' + unit1 + 's' : '';
      }
    });
    if (document.activeElement !== inp) inp.value = st.packs;
    var sl = $('lt-qsl');
    if (sl && document.activeElement !== sl) sl.value = packsToQsl(st.packs);
    if (sl) sl.setAttribute('aria-label', 'Slide to choose how many ' + unit1 + 's');
    var p = quoteFor(st.packs);
    var lab = $('lt-qlab');
    if (lab) {
      lab.textContent = sealNum(p.n) + ' label' + (p.n === 1 ? '' : 's') +
        (combo && ls.length === 2
          ? ' (' + sealNum(ls[0].v.perPack * st.packs) + ' + ' +
            sealNum(ls[1].v.perPack * st.packs) + ')' : '');
    }
    var was = $('lt-qwas');
    if (was) {
      if (p.rate) { was.style.display = ''; was.textContent = fmtMoney(p.gross); }
      else was.style.display = 'none';
    }
    var tot = $('lt-qtot');
    if (tot) tot.textContent = fmtMoney(p.price);
    var perEl = $('lt-qper');
    if (perEl) {
      /* a combo mixes two prices, so its per-label figure is an average and
         says so */
      var perTxt = (p.n ? fmtPerSeal(p.price / p.n) : fmtMoney(0)) + ' per label' +
        (combo ? ' on average' : '');
      perEl.textContent = p.rate
        ? pctOf(p.rate) + '% off — you save ' + fmtMoney(p.save) + ' · ' + perTxt
        : perTxt;
    }
    var un = $('lt-qunit');
    if (un) un.textContent = unitWord(st.packs);   /* the CSS uppercases it */
    var pl = $('lt-packline');
    if (pl && ls.length) {
      pl.textContent = combo && ls.length === 2
        ? '1 set = ' + ls[0].v.perPack + ' Standard + ' + ls[1].v.perPack +
          ' Large labels · minimum ' + MIN_UNITS + ' sets (' +
          sealNum(MIN_UNITS * (ls[0].v.perPack + ls[1].v.perPack)) + ' labels)'
        : ls[0].v.perPack + ' labels per pack · minimum ' + MIN_UNITS + ' packs (' +
          sealNum(MIN_UNITS * ls[0].v.perPack) + ' labels)';
    }
    /* the lit chip is the tile of the BAND the order is in, not just an earned
       discount */
    var band = 0;
    document.querySelectorAll('#lt-qtier .qd-tier').forEach(function (t2) {
      var th = parseInt(t2.getAttribute('data-lttier'), 10);
      if (st.packs >= th && th >= band) band = th;
    });
    document.querySelectorAll('#lt-qtier .qd-tier').forEach(function (t2) {
      var on = parseInt(t2.getAttribute('data-lttier'), 10) === band;
      t2.classList.toggle('on', on);
      t2.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* Near-miss nudge, in the STEPPER'S unit — packs, or sets in the combo.
       Naming a number that does not cross the threshold sends a customer to a
       discount they then do not get. */
    var nudge = $('lt-qnudge');
    if (nudge) {
      var nx = nextTier(st.packs);
      var hadFocus = nudge.contains(document.activeElement);
      if (nx && nx[0] <= maxUnits()) {
        var need = nx[0] - st.packs;
        var uw = unit1 + (need === 1 ? '' : 's');
        nudge.style.display = '';
        nudge.innerHTML = '<button type="button" class="qn-go" data-lttier="' + nx[0] + '"' +
          ' aria-label="Add ' + need + ' more ' + uw +
          ' to get ' + pctOf(nx[1]) + ' percent off your whole order">' +
          '<b>' + need + ' more ' + uw + '</b>' +
          '<span>→</span><b>' + pctOf(nx[1]) + '% off</b>' +
          '<span>your whole order</span></button>';
        if (hadFocus) _refocus('#lt-qnudge .qn-go');
      } else { nudge.style.display = 'none'; nudge.innerHTML = ''; }
    }
    paintRush();
  }

  /* ═══════════════ RUSH — Skip the Production Line ═══════════════════════ */

  var _cartLabels = 0;
  function rushTotalLabels() { return _cartLabels + totalLabels(); }
  function rushTier() { return rushTierFor(rushTotalLabels()); }
  function rushPriceStr(t) { return money((t || rushTier()).cents); }

  function renderRush() {
    var host = $('lt-rush');
    if (!host) return;
    /* a Draft/missing product, or a ladder that failed to join, renders
       NOTHING at all rather than an unbuyable or mispriced row */
    if (!RUSH.ok) { host.innerHTML = ''; st.rush = false; return; }
    if ($('lt-rush-cb')) { paintRush(); return; }
    host.innerHTML =
      '<div class="rushslide" id="lt-rush-cb" role="switch" tabindex="0" aria-checked="false"' +
        ' aria-label="Slide or tap to add priority production">' +
        '<span class="rs-track-label"><span class="rs-shimmer">⚡ Slide to Skip the ' +
        'Production Line</span><i id="lt-rush-price"></i></span>' +
        '<span class="rs-thumb" aria-hidden="true">»</span>' +
      '</div>' +
      '<span class="rs-cap">Your labels print ahead of the standard queue · production ' +
      'speed, not shipping speed · refunded in full if we do not move your order ahead of ' +
      'the queue</span>' +
      /* SAY WHY THE PRICE IS WHAT IT IS. The fee is priced on the WHOLE order,
         so with labels already in the cart every press of -/+ here can leave the
         total inside the same rung — and a correct fee then reads as a frozen
         one. Naming both halves is the difference between "this is broken" and
         "oh, that is my cart". */
      '<span class="rs-cap" id="lt-rush-note"></span>';
    var cb = $('lt-rush-cb');
    var th = cb.querySelector('.rs-thumb');
    function rsMax() { return Math.max(60, cb.clientWidth - th.offsetWidth - 10); }
    /* the parked (engaged) position is MEASURED, not guessed — a fixed
       translate left the thumb stranded mid-bar on wider phones */
    function rsPark() { try { cb.style.setProperty('--rs-max', rsMax() + 'px'); } catch (_) {} }
    rsPark();
    addEventListener('resize', rsPark);
    /* ENGAGING IS A SLIDE, never a tap — a paid add-on must not be a fat-thumb
       accident. Removing is a tap on the green bar. */
    var _drag = null, _swallow = false;
    th.addEventListener('pointerdown', function (e) {
      if (st.rush) return;
      _drag = { x: e.clientX, dx: 0 };
      cb.classList.add('drag');
      try { th.setPointerCapture(e.pointerId); } catch (_) {}
    });
    th.addEventListener('pointermove', function (e) {
      if (!_drag) return;
      _drag.dx = Math.max(0, Math.min(rsMax(), e.clientX - _drag.x));
      th.style.transform = 'translateX(' + _drag.dx + 'px)';
    });
    function rsEnd() {
      if (!_drag) return;
      /* WCAG 2.5.7 Dragging Movements: a plain TAP on the thumb engages it too,
         so a pointer user who cannot drag still has a path. The target is the
         50px thumb, not the whole bar. */
      var ok = _drag.dx > rsMax() * 0.7 || _drag.dx < 4;
      _drag = null;
      cb.classList.remove('drag');
      th.style.transform = '';
      /* the browser synthesizes a CLICK after the drag; without this it lands
         on the track handler and switches the fee straight back off */
      _swallow = true;
      setTimeout(function () { _swallow = false; }, 350);
      if (ok) { st.rush = true; buzz(20); sync(); }
    }
    th.addEventListener('pointerup', rsEnd);
    th.addEventListener('pointercancel', rsEnd);
    cb.addEventListener('click', function () {
      if (_swallow) return;
      if (st.rush) { st.rush = false; buzz(10); sync(); }
    });
    cb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); st.rush = !st.rush; buzz(12); sync();
      }
    });
    paintRush();
  }
  function paintRush() {
    if (!RUSH.ok) return;
    var cb = $('lt-rush-cb');
    if (!cb) { renderRush(); return; }
    try {
      var thW = (cb.querySelector('.rs-thumb') || {}).offsetWidth || 50;
      cb.style.setProperty('--rs-max', Math.max(60, cb.clientWidth - thW - 10) + 'px');
    } catch (_) {}
    cb.classList.toggle('on', !!st.rush);
    cb.setAttribute('aria-checked', st.rush ? 'true' : 'false');
    var sh = cb.querySelector('.rs-shimmer');
    if (sh) sh.textContent = st.rush
      ? 'Priority added — tap to remove'
      : '⚡ Slide to Skip the Production Line';
    var th2 = cb.querySelector('.rs-thumb');
    if (th2 && !cb.classList.contains('drag')) th2.style.transform = '';
    var pe = $('lt-rush-price');
    if (pe) pe.textContent = '— ' + rushPriceStr();
    var ne = $('lt-rush-note');
    if (ne) {
      ne.textContent = _cartLabels > 0
        ? 'Priced on your whole order: ' + sealNum(_cartLabels) + ' already in your cart + ' +
          sealNum(totalLabels()) + ' here = ' + sealNum(rushTotalLabels()) + ' labels'
        : 'Priced on your whole order · currently ' + sealNum(rushTotalLabels()) + ' labels';
    }
  }
  /* read /cart.js once at boot so a rush line already in the cart pre-ticks
     the control instead of contradicting it, and so the fee is priced on the
     WHOLE order rather than on this line alone */
  function refreshCartLabels() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        _cartLabels = cartLabelsOf(c);
        /* the line being EDITED is already counted in `c`, and totalLabels()
           adds it again — a single 50-pack line under edit quoted "600 already
           in your cart + 600 here = 1,200 labels" and priced a rung above the
           one checkout charges (placeOrder removes the old line and re-reads
           /cart.js, so the fee actually added was the lower one). */
        if (st.editKey) {
          var mine = (c.items || []).filter(function (i) {
            return String(i.key) === String(st.editKey);
          });
          if (mine.length) _cartLabels -= cartLabelsOf({ items: mine });
          if (_cartLabels < 0) _cartLabels = 0;
        }
        if (cartRushLine(c)) st.rush = true;
        paintRush();
      }).catch(function () {});
  }

  /* ═══════════════ THE PROBE / WHAT A STYLE DROPS ════════════════════════ */

  /* which FILLED fields a style has no room for, by their own key — the key
     matters, because the styles that carry addr1 are not the styles that carry
     addr2 and naming the wrong set is worse than saying nothing */
  var DROPPABLE = [['addr1', 'first address line'], ['addr2', 'second address line'],
                   ['note', 'extra line'], ['social', 'social handle'],
                   ['reward', 'reward line'], ['email', 'email']];
  function labelOf(key) {
    for (var i = 0; i < DROPPABLE.length; i++) if (DROPPABLE[i][0] === key) return DROPPABLE[i][1];
    return key;
  }
  /* ── the probe ──
     `lay.carries` is a DECLARATION; svg() decides per design, because the
     detail stack runs out of ROWS before it runs out of fields (Call Me keeps
     a social handle until an email is added, then loses it). Asking the
     declaration alone let a customer type an address, see no warning, and get
     a label — and a press cell — without it.

     The host must be ATTACHED and laid out at the die's own pixel width: a
     detached or display:none host measures every run as 0, fit() skips it and
     the probe would pass anything. */
  function probe(fn, sizeId) {
    /* sizeId: the combo measures its derived Large label on the Large die */
    var SZ = sizeId ? LT.sizeOf(sizeId) : size();
    var host = document.createElement('div');
    host.style.cssText = 'position:absolute;left:-99999px;top:0;width:' + SZ.pxLong + 'px';
    document.body.appendChild(host);
    function mountOne(t, layoutKey) {
      var c = cfgOf(t);
      if (layoutKey) c.layout = layoutKey;
      return LT.mount(host, c, { size_id: SZ.id, print: true }) || {};
    }
    try { return fn(mountOne, SZ); }
    finally { try { document.body.removeChild(host); } catch (_) {} }
  }
  /* the CONTENT fields a mount dropped. 'qr' and 'logo' are not fields and
     carry notes of their own, so they never reach this list. */
  function lostKeys(r) {
    return ((r || {}).dropped || []).filter(function (k, i, a) {
      return k !== 'qr' && k !== 'logo' && a.indexOf(k) === i;
    });
  }
  function droppedFields(t, lay, mount) {
    var carries = (lay && lay.carries) || [];
    var seen = {}, out = [];
    function add(key) {
      if (seen[key]) return;
      seen[key] = 1;
      out.push({ key: key, label: labelOf(key) });
    }
    DROPPABLE.forEach(function (p) {
      if (t[p[0]] && carries.indexOf(p[0]) < 0) add(p[0]);
    });
    if (mount) lostKeys(mount(t)).forEach(add);
    return out;
  }
  function andList(a) {
    if (a.length < 2) return a.join('');
    return a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }
  /* the styles that actually keep these fields FOR THIS DESIGN. A `carries`
     match is necessary and not sufficient, so each candidate is mounted with
     the customer's own content before it is named — recommending a style that
     drops the field too is the same lie one screen later. */
  function carriersFor(keys, t, mount) {
    var names = LT.layoutsFor(st.sizeId).filter(function (l) {
      var c = l.carries || [];
      for (var i = 0; i < keys.length; i++) if (c.indexOf(keys[i]) < 0) return false;
      if (!mount || !t) return true;
      var lost = lostKeys(mount(t, l.key));
      for (var j = 0; j < keys.length; j++) if (lost.indexOf(keys[j]) >= 0) return false;
      return true;
    }).map(function (l) { return l.name; });
    if (names.length) return 'it prints on ' + andList(names);
    /* no promise about the other die — nothing here has mounted it */
    return st.sizeId === SID_LG
      ? 'no other style on this size fits it either, so shorten the label or leave it out'
      : 'no other style on this size fits it either — try the Large size, or shorten the label';
  }

  /* every label must render readably — refuse to sell type below the floor,
     and refuse to sell a label the renderer is going to print WITHOUT a line
     the customer typed. `dropped` is the renderer's own answer for this exact
     design; nothing may reach the cart carrying content that never prints. */
  function fitOne(t, lay, r, i, pre) {
    if (r.minText !== null && r.minText < LT.MIN_TEXT) {
      return { i: i, msg: pre + 'This text is too long for the ' + lay.name +
        ' style — shorten it or choose another style.' };
    }
    if (r.dropped && r.dropped.indexOf('qr') >= 0) {
      return { i: i, msg: pre + 'The ' + lay.name + ' style cannot carry that code — ' +
        'choose another style, or another action in the QR card.' };
    }
    var lost = lostKeys(r);
    if (lost.length) {
      return { i: i, msg: pre + 'The ' + lay.name + ' style has no room for ' +
        andList(lost.map(labelOf)) + ' on this label — remove a line, or choose ' +
        'another style.' };
    }
    return null;
  }
  function fitCheck() {
    var bad = [];
    probe(function (mountOne) {
      st.labels.forEach(function (t, i) {
        var e = fitOne(t, layoutOf(t), mountOne(t), i, '');
        if (e) bad.push(e);
      });
    });
    /* THE COMBO SELLS A SECOND LABEL, so the renderer's own verdict on the
       derived Large design gates the add exactly as the Standard one does */
    if (isCombo() && !bad.length) {
      probe(function (mountOne) {
        st.labels.forEach(function (t, i) {
          var tl = comboLg(t);
          var e = fitOne(tl, layoutObj(SID_LG, tl.layout), mountOne(tl), i,
                         'On the Large label: ');
          if (e) bad.push(e);
        });
      }, SID_LG);
    }
    return bad;
  }

  /* ═══════════════ VALIDATION ════════════════════════════════════════════
     Every message states the fix, not the rule. */

  function contactIssue(t) {
    if (!String(t.name || '').trim()) return { f: 'f-name', m: 'Add the name a finder should ask for.' };
    if (t.phone && !e164Ok(toE164(t.phone, st.cc))) {
      return { f: 'f-phone', m: 'That does not look like a full phone number — include the ' +
        'country code, like +1 555 123 4567.' };
    }
    if (t.email && !emailOk(t.email)) return { f: 'f-email', m: 'That does not look like an email address.' };
    if (t.social && !socialOk(t.social)) {
      return { f: 'f-social', m: 'Handles are letters, numbers, dots and underscores.' };
    }
    if (!hasRoute(t)) {
      return { f: 'f-route', m: 'A finder needs a way to reach you — add a phone number or an email.' };
    }
    return null;
  }
  /* `fix` allows the ONE mutation this function may make (dropping an optional
     sms body / mail subject to save an over-budget code). blockers() runs on
     every keystroke and must never eat the customer's words, so only
     placeOrder() passes it. */
  function qrIssue(t, fix) {
    if (!t.qa || t.qa === 'none') return null;
    if (t.qa === 'call' || t.qa === 'text' || t.qa === 'whatsapp') {
      if (!e164Ok(t.e164)) {
        return { f: 'f-qr', m: 'Add the phone number the code should ' +
          (t.qa === 'call' ? 'call' : (t.qa === 'text' ? 'text' : 'open')) + '.', at: 'f-phone' };
      }
    }
    if (t.qa === 'email' && !emailOk(t.email)) {
      return { f: 'f-qr', m: 'Add the email address the code should open.', at: 'f-email' };
    }
    if (t.qa === 'instagram') {
      var ig = String(t.social || t.qd || '').replace(/^@+/, '')
        .replace(/^(?:https?:\/\/)?(?:www\.)?instagram\.com\//i, '');
      if (!socialOk(ig)) return { f: 'f-qr', m: 'Add the handle the code should open.' };
    }
    if (t.qa === 'web') {
      if (BAD_SCHEME.test(t.qd)) {
        return { f: 'f-qr', m: 'That link cannot be used — enter a website or profile address.' };
      }
      if (!String(t.qd || '').trim()) return { f: 'f-qr', m: 'Add the web address the code should open.' };
      if (!hasRoute(t) || (!t.phone && !t.email)) {
        return { f: 'f-qr', m: 'A web address on its own is not a way to reach you — add a ' +
          'phone number or an email as well.', at: 'f-phone' };
      }
    }
    var q = qrState(t);
    if (!q.payload) return { f: 'f-qr', m: 'That code has nothing to open yet — fill the field above.' };
    if (q.over) {
      /* AUTO-DEGRADE FIRST: drop the optional part and say so, and only error
         if it is still too dense */
      if (fix && t.qb) {
        var keep = t.qb;
        t.qb = '';
        if (!qrState(t).over) {
          return { f: 'f-qr', soft: true,
                   m: (t.qa === 'email' ? 'Your subject line was dropped' : 'Your message was dropped') +
                      ' to keep the code scannable.' };
        }
        /* dropping it did not save the code, so give the customer their words
           back rather than eating them on the way to an error */
        t.qb = keep;
      }
      return { f: 'f-qr', over: true,
               m: 'That is too long to scan at this size — the ' + size().shortName +
                  ' label holds about ' + q.cap + ' characters.' };
    }
    return null;
  }

  /* ═══════════════ BLOCKERS + THE ONE CTA ════════════════════════════════ */

  /* where the FIRST blocker sends the customer. Set while blockers() builds,
     read by the CTA tap. */
  var _blockAt = '';
  var FOCUS_MAP = {
    'f-name': 'f-name', 'f-phone': 'f-phone', 'f-email': 'f-email',
    'f-social': 'f-social', 'f-route': 'lt-details-head', 'f-qr': 'lt-qropts',
    'f-size': 'lt-size-pick', 'f-mat': 'lt-matpick', 'f-packs': 'lt-packs',
    'f-logo': 'lt-logo-tile', 'f-style': 'lt-laycar'
  };
  function blockers() {
    var t = cur(), out = [], at = '';
    function push(msg, f) { out.push(msg); if (!at) at = f || ''; }
    if (!variant()) push('That size and material are not on sale right now — pick another', 'f-size');
    if (isCombo() && !lgComboVariant()) {
      push('The Large size is not on sale right now — choose Standard only', 'f-size');
    }
    if (st._editBad) push(st._editErr || 'Pick the size and material again before updating ' +
      'that cart line.', 'f-size');
    var ci = contactIssue(t);
    if (ci) push(ci.m, ci.f);
    var qi = qrIssue(t);
    if (qi) push(qi.m, qi.at || qi.f);
    if ((t.lo || t._data) && !st.rightsOk) push('Confirm you have the rights to the logo', 'f-logo');
    /* a logo that never reached the Worker is not a note for the shop floor to
       find, it is a label that would print without the mark the customer chose */
    if (st.logo && (st.logo.uploadErr ||
        (st.logo.dataUrl && !st.logo.url && !st.logo.uploadP))) {
      push('Your logo did not save — replace it or remove it before ordering', 'f-logo');
    }
    if (st._fit) push(st._fit, 'f-style');
    if (!(st.packs >= MIN_UNITS)) {
      push('The minimum order is ' + MIN_UNITS + ' ' + unitWord(MIN_UNITS) + ' (' +
        sealNum(MIN_UNITS * labelsPerUnit()) + ' labels)', 'f-packs');
    }
    _blockAt = at;
    return out;
  }
  function paintCta(btnId, needId, need, ready) {
    var b = $(btnId);
    if (b) {
      b.setAttribute('aria-disabled', ready ? 'false' : 'true');
      /* the label does NOT change with readiness: the line under it already
         says what is missing, and one stable word is what a customer looks for
         when they are ready to buy */
      b.textContent = st.editKey ? 'Update cart' : 'Add to cart';
    }
    var n = needId && $(needId);
    if (n) {
      n.className = 'needline' + (ready ? ' ready' : '');
      n.textContent = ready
        ? (st.editKey ? '✓ Ready to update your cart.' : '✓ Ready to order.')
        : '→ ' + need[0] + (need.length > 1 ? '  (' + (need.length - 1) + ' more to go)' : '');
    }
  }
  function summaryRows() {
    var v = variant(), p = quoteFor(st.packs), SZ = size();
    var rows;
    var ls = orderLines(st.packs);
    if (isCombo() && ls.length === 2) {
      var LZ = LT.sizeOf(SID_LG), tl = comboLg(cur());
      var sn = layoutOf(cur()).name, lnm = layoutObj(SID_LG, tl.layout).name;
      rows = [
        ['Size', 'Combo: ' + SZ.label + ' + ' + LZ.label],
        ['Material', ls[0].v.material === ls[1].v.material ? ls[0].v.material
          : 'Standard ' + ls[0].v.material + ' · Large ' + ls[1].v.material],
        ['Style', sn === lnm ? sn : 'Standard ' + sn + ' · Large ' + lnm],
        ['Background', bgOf(cur().bg).name],
        ['Sets', st.packs + ' × (' + ls[0].v.perPack + ' Standard + ' + ls[1].v.perPack +
          ' Large)'],
        ['Labels', sealNum(totalLabels())]
      ];
    } else {
      rows = [
        ['Size', SZ.label],
        ['Material', st.material],
        ['Style', layoutOf(cur()).name],
        ['Background', bgOf(cur().bg).name],
        ['Packs', st.packs + ' × ' + perPack() + ' labels'],
        ['Labels', sealNum(totalLabels())]
      ];
    }
    if (p.rate) rows.push(['Volume discount', pctOf(p.rate) + '% − ' + fmtMoney(p.save)]);
    var html = rows.map(function (r) {
      return '<div class="sumline"><span class="k">' + esc(r[0]) + '</span>' +
        '<span class="v">' + esc(r[1]) + '</span></div>';
    }).join('');
    html += '<div class="sumline"><span class="k">Total</span>' +
      '<span class="v price-big">' + fmtMoney(v ? p.price : 0) + '</span></div>';
    if (st.rush && RUSH.ok) {
      html += '<div class="sumline"><span class="k">Skip the Production Line</span>' +
        '<span class="v">' + rushPriceStr() + ' at checkout</span></div>';
    }
    return html;
  }

  var _fitT = null;
  function runFitCheck() {
    try {
      var bad = fitCheck();
      var was = st._fit;
      st._fit = bad.length ? bad[0].msg : '';
      if (was !== st._fit) {
        var need = blockers();
        paintCta('lt-cta', 'lt-need', need, !need.length);
        paintCta('lt-bar-cta', null, need, !need.length);
      }
    } catch (_) { st._fit = ''; }
  }

  /* ONE RENDER PIPELINE. Everything a change can affect is repainted here, in
     one place — and nothing that holds focus is rebuilt: the details card, the
     QR card and the strips are rebuilt only by their own handlers. */
  function sync() {
    if (!OK) return;
    schedulePreview();
    scheduleStripMinis();
    renderQuantity();
    /* paintDensity(), NOT renderQrChip(): four of the seven actions (Call, Text,
       WhatsApp, Email) derive their payload from a field that lives in the
       DETAILS card, so the byte meter and the printed-fallback line only ever
       moved for the two actions typed inside the QR card itself. paintDensity()
       ends by calling renderQrChip(), null-guards both <p>s and rewrites nothing
       that can hold focus — which is what it was written for. */
    paintDensity();
    scheduleLayNote();
    var sr = $('lt-sumrows');
    if (sr) sr.innerHTML = summaryRows();
    var bp = $('lt-bar-price');
    if (bp) bp.textContent = fmtMoney(quoteFor(st.packs).price);
    var need = blockers(), ready = !need.length;
    paintCta('lt-cta', 'lt-need', need, ready);
    paintCta('lt-bar-cta', null, need, ready);
    saveDraft();
    clearTimeout(_fitT);
    _fitT = setTimeout(runFitCheck, 1000);
  }

  /* ═══════════════ ADD TO CART ═══════════════════════════════════════════ */

  var _busy = false;
  function ctaTap() {
    if (_busy) return;
    var need = blockers();
    if (need.length) {
      toast(need[0], true);
      var el = $(FOCUS_MAP[_blockAt] || 'lt-form');
      if (el) { smoothTo(el, 'center'); hilite(el.closest('.field') || el); }
      return;
    }
    placeOrder();
  }
  function setBusy(on, label) {
    _busy = on;
    [$('lt-cta'), $('lt-bar-cta')].forEach(function (b) {
      if (!b) return;
      b.disabled = on;
      if (on && label) b.textContent = label;
    });
    if (!on) {
      var need = blockers();
      paintCta('lt-cta', 'lt-need', need, !need.length);
      paintCta('lt-bar-cta', null, need, !need.length);
    }
  }
  function placeOrder() {
    var v = variant();
    if (!v || !orderLines(st.packs).length) {
      toast('That size and material are not on sale right now — pick another', true);
      smoothTo($('lt-size-pick'), 'center');
      return;
    }
    var t = cur();
    /* one soft pass at the QR: dropping an optional sms body to save the code
       is a fix, and it is announced */
    var qi = qrIssue(t, true);
    if (qi && qi.soft) { renderQr(); sync(); toast(qi.m, true); }
    else if (qi) {
      toast(qi.m, true);
      smoothTo($(FOCUS_MAP[qi.at || 'f-qr']) || $('lt-qropts'), 'center');
      return;
    }
    var bad = fitCheck();
    if (bad.length) {
      st._fit = bad[0].msg;
      toast(bad[0].msg, true);
      smoothTo($('lt-laycar'), 'center');
      sync();
      return;
    }
    st._fit = '';
    var hasLogo = !!(t.lo || t._data);
    if (hasLogo && !st.rightsOk) {
      toast('Confirm you have the rights to the logo', true);
      var rr = $('lt-rights-row');
      if (rr) { smoothTo(rr, 'center'); hilite(rr); }
      return;
    }
    /* ONE design carries the whole line: the design die's own packs */
    t.q = perPack() * st.packs;
    var wire = JSON.stringify(wirePayload());
    if (LT.qrBytes(wire) > PAYLOAD_MAX) {
      toast('That is more design detail than one cart line can carry — shorten a few lines.',
            true);
      return;
    }
    /* wait for a logo still uploading — the URL is the production artwork */
    var pending = (st.logo && st.logo.uploadP && !st.logo.url && !st.logo.uploadErr)
      ? [st.logo.uploadP] : [];
    setBusy(true, pending.length ? 'Saving your logo…' : 'Adding…');

    var belt = new Promise(function (res) { setTimeout(res, 30000); });
    Promise.race([Promise.all(pending), belt]).then(function () {
      syncLogoToLabel();
      /* RE-READ THE COUNT. `total` was taken before the logo wait, and setBusy()
         only freezes the two CTAs — the stepper, the slider, the tier chips and
         the nudge all stayed live during "Saving your logo…". A nudge tapped in
         that window used to ship quantity 9 with Pack '24 labels' and
         _lt_count '24': the customer is charged and shipped 108 labels while
         the order line, the confirmation email and the packing slip say 24, and
         Label Farm's own guard compares assigned against per_pack x quantity,
         so it passes. Everything below reads total2. */
      var total2 = totalLabels();
      /* ONE LINE PER DIE. Single-size mode writes one line; the combo writes
         TWO ordinary lines — the Standard design and its derived Large twin —
         each with its own die's `_lt`, count and variant, in the SAME
         /cart/add.js request so a set lands whole or not at all. */
      if (!(st.packs >= MIN_UNITS)) throw new Error('under the minimum');
      var lines = orderLines(st.packs);
      if (!lines.length) throw new Error('no variant');
      var logoNote = !!(st.logo && (st.logo.uploadErr || (st.logo.dataUrl && !st.logo.url)));
      var lineItems = lines.map(function (L) {
        var tt = L.sizeId === st.sizeId ? t : comboLg(t);
        var n = L.v.perPack * st.packs;
        tt.q = n;
        var Z = LT.sizeOf(L.sizeId);
        /* PUBLIC properties are generic on purpose — no contact string ever
           leaves the private `_lt` payload. */
        var props = {
          'Pack': n + ' labels',
          'Designs': '1',
          'Size': Z.label,
          'Material': L.v.material,
          '_lost_order': '1',
          '_lt_count': String(n),
          '_lt': JSON.stringify(wirePayload(L.sizeId, [tt]))
        };
        /* the Label Farm press-routing key, on LARGE lines only. Never write
           _label_size_id on a cart line: ss-cart.js's isLargeLine() would pool
           a lost label into the large-SEAL price ladder. Ingest stamps the id
           on the JOB from the SKU's 'W'. */
        if (L.sizeId === SID_LG) props['_label_size_mm'] = Z.mm;
        if (hasLogo) props['_rights_ack'] = 'agreed';
        /* PRIVATE key. A public 'Logo note' shows at checkout and still never
           reaches the shop floor: Label Farm builds its job props from a fixed
           key list. blockers() now refuses the add outright (see below), so
           this is only reachable when the 30 s belt beat a slow upload. */
        if (logoNote) props['_lt_logo_note'] = 'upload did not finish — we will email for the file';
        return { id: L.v.id, quantity: st.packs, properties: props };
      });

      /* edit-from-cart: remove the OLD line before re-adding, or every edit
         mints a duplicate */
      /* fetch() only rejects on a NETWORK error, so a 404/422 (the line key
         went stale — another tab changed the cart, or this key was already
         removed) used to resolve happily and the chain carried on to the add,
         minting exactly the duplicate this removal exists to prevent. Throw,
         and let the outer .catch say so. */
      var pre = st.editKey
        ? fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: st.editKey, quantity: 0 })
          }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); })
        : Promise.resolve();

      return pre.then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return { items: [] }; });
      }).then(function (cart) {
        var plan = rushPlan(cart, total2, st.rush);
        var items = lineItems.slice();
        var pre2 = plan.stale && plan.line
          ? fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: plan.line.key, quantity: 0 })
            }).then(function (r) {
              /* survivable: ss-cart.js reconciles the fee on /cart. Not
                 silent, because a stale rung left behind is a real charge. */
              if (!r.ok && window.console) console.warn('[lt] stale rush line not removed', r.status);
            }).catch(function () {})
          : Promise.resolve();
        return pre2.then(function () {
          if (plan.add) items.push(rushLine(plan.tier, plan.labels));
          /* ONE add, all or nothing */
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        });
      }).then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        try { localStorage.removeItem('lt_draft'); } catch (_) {}
        try { sessionStorage.removeItem('lt_editkey'); } catch (_) {}
        location.href = '/cart';
      });
    }).catch(function () {
      setBusy(false);
      toast(st.editKey
        ? 'Could not update your cart — please try again.'
        : 'Could not add to cart — please try again.', true);
    });
  }

  /* ═══════════════ THE STICKY BAR ════════════════════════════════════════ */

  function wireBar() {
    var bar = $('lt-bar');
    if (!bar) return;
    /* #ss-toast reads --barh so it never renders behind the bar. The seal's
       syncBarHeight() is a no-op stub because it has no bar; ours measures. */
    function measure() {
      try {
        document.documentElement.style.setProperty('--barh',
          (bar.offsetHeight || 74) + 'px');
      } catch (_) {}
    }
    measure();
    addEventListener('resize', measure);
    /* the bar hides itself while the in-flow CTA is on screen — one button in
       view at a time, and the in-flow one is the one with the reason under it */
    try {
      var anchor = $('lt-buy');
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          bar.classList.toggle('ltb-bar--off', !!(en[0] && en[0].isIntersecting));
        }, { rootMargin: '0px 0px -56px 0px' }).observe(anchor);
      }
    } catch (_) {}
  }

  /* ═══════════════ BOOT ══════════════════════════════════════════════════ */

  function wireQuantity() {
    document.querySelectorAll('#lt-packs .va-qsb').forEach(function (b) {
      b.onclick = function () {
        setPacks(st.packs + parseInt(this.getAttribute('data-qd'), 10));
      };
    });
    var qin = $('lt-qin');
    if (qin) {
      qin.min = MIN_UNITS; qin.step = 1; qin.max = maxUnits();
      qin.oninput = function () {
        var v = parseInt(this.value, 10);
        /* leave a half-typed value alone rather than snapping it out from
           under the caret */
        if (!isNaN(v) && v >= MIN_UNITS) setPacks(v);
      };
      qin.onblur = function () { setPacks(this.value); this.value = st.packs; };
    }
    var qsl = $('lt-qsl'), last = 0;
    if (qsl) {
      qsl.oninput = function () {
        var k = qslToPacks(this.value);
        if (k !== last) { last = k; buzz(4); }
        setPacks(k);
      };
    }
    /* ONE delegated listener for every tier surface: the chips and the nudge
       are rebuilt on every quantity change, so per-element handlers would go
       stale the first time one was missed. They are real <button>s, so Enter
       and Space arrive here as clicks already. */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-lttier]');
      if (t) applyTier(t.getAttribute('data-lttier'));
    });
    /* slider drag affordance: wiggle it once when it first scrolls into view,
       and kill the wiggle AND the hint on the first real drag */
    (function () {
      var sl = $('lt-qsl'), hint = $('lt-qsl-hint');
      if (!sl) return;
      function used() {
        sl.classList.remove('qsl-nudge');
        var h2 = hint || $('lt-qsl-hint');
        if (h2) h2.classList.add('off');
        sl.removeEventListener('pointerdown', used);
        sl.removeEventListener('input', used);
      }
      sl.addEventListener('pointerdown', used);
      sl.addEventListener('input', used);
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { sl.classList.add('qsl-nudge'); io.disconnect(); }
          });
        }, { threshold: 0.6 });
        io.observe(sl);
      } else sl.classList.add('qsl-nudge');
    })();
  }

  function boot() {
    var root = $('lt-root');
    if (!OK) {
      var form = $('lt-form');
      if (form) {
        form.innerHTML = '<p class="trustline">The Lost &amp; Found labels are not available ' +
          'right now — please check back shortly.</p>';
      }
      var bar = $('lt-bar');
      if (bar) bar.style.display = 'none';
      return;
    }
    loadDraft();
    paintRootMode();

    var legal = $('lt-legal');
    if (legal) {
      legal.innerHTML = '<b>Printed to order.</b> ' + esc(LEGAL_MEDIUM) +
        ' Every label is printed from the text you type, so an order cannot be changed once ' +
        'it goes to the press — check the preview. If a label arrives damaged or wrong, we ' +
        'reprint it. The printer lays no white ink: open and pale areas are the holographic ' +
        'material itself showing through.';
    }

    renderSizeCards();
    renderLayouts();
    renderBgCarousel();
    renderDetails();
    renderQr();
    renderMaterial();
    mountUploader();
    renderQtiers();
    renderRush();
    setDims();
    wireStripMouse();
    wireQuantity();
    wireBar();

    var tile = $('lt-logo-tile');
    if (tile) tile.onclick = function () { pickFile('logo'); };
    var exp = $('lt-exp');
    if (exp) exp.onclick = function () {
      var m = $('lt-mbar');
      var open = m.classList.toggle('open');
      exp.setAttribute('aria-expanded', open ? 'true' : 'false');
      exp.innerHTML = 'Order details ' + (open ? '▴' : '▾');
    };
    var cta = $('lt-cta'), bcta = $('lt-bar-cta');
    if (cta) cta.onclick = ctaTap;
    if (bcta) bcta.onclick = ctaTap;

    if (st._editErr) toast(st._editErr, true);
    else if (st._minRaised) {
      toast('Lost & Found labels now have a ' + MIN_UNITS + '-pack minimum — this line ' +
        'is set to ' + MIN_UNITS + ' packs.', true);
    }
    refreshCartLabels();
    renderPreview();
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* the debug/test handle. LIVE REFERENCES — st is the actual state object,
     not a copy, so tools/lt_builder_check.py drives the real builder. */
  window.LTB = {
    st: st, VARIANTS: VARIANTS, variantFor: variantFor, variantById: variantById,
    RUSH: RUSH, rushPlan: rushPlan, cartLabelsOf: cartLabelsOf,
    toCompact: toCompact, fromCompact: fromCompact, wirePayload: wirePayload,
    qrState: qrState, toE164: toE164, totalLabels: totalLabels,
    quoteFor: quoteFor, PAYLOAD_MAX: PAYLOAD_MAX, MAX_PACKS: MAX_PACKS,
    MIN_UNITS: MIN_UNITS,
    /* the combo (owner 2026-09-28) */
    applyMode: applyMode, isCombo: isCombo, orderLines: orderLines, comboLg: comboLg,
    lgLayoutOf: lgLayoutOf, maxUnits: maxUnits, labelsPerUnit: labelsPerUnit,
    /* the entry points a harness drives */
    setPacks: setPacks, applySize: applySize, blockers: blockers, sync: sync,
    cur: cur, renderQr: renderQr, renderDetails: renderDetails,
    /* the pre-cart gate, so a harness can prove a design that loses a typed
       line is REFUSED without writing to the cart */
    fitCheck: fitCheck, droppedFields: droppedFields, probe: probe
  };
})();
